// We currently don't use Prefix, State, or DistributionCenter. So these are
// commented out to decrease the bundle size.
export interface ZipCodePrefix {
  // Prefix: string;
  // State: string;
  // DistributionCenter: string;
  CitiesTowns: string;
}

export const ZipCodePrefixes: { [key: string]: ZipCodePrefix } = {
  "000": {
    // Prefix: "000",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "001": {
    // Prefix: "001",
    // State: "International Mail",
    // DistributionCenter: "International Mail",
    CitiesTowns: "International Mail",
  },
  "002": {
    // Prefix: "002",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "003": {
    // Prefix: "003",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "004": {
    // Prefix: "004",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "005": {
    // Prefix: "005",
    // State: "NY",
    // DistributionCenter: "Holtsville",
    CitiesTowns: "IRS",
  },
  "006": {
    // Prefix: "006",
    // State: "PR",
    // DistributionCenter: "San Juan",
    CitiesTowns: "Arecibo, Mayaguez, Northern Puerto Rico",
  },
  "007": {
    // Prefix: "007",
    // State: "PR",
    // DistributionCenter: "San Juan",
    CitiesTowns: "Ponce, Caguas, Southern Puerto Rico",
  },
  "008": {
    // Prefix: "008",
    // State: "VI",
    // DistributionCenter: "San Juan, PR",
    CitiesTowns: "U.S. Virgin Islands",
  },
  "009": {
    // Prefix: "009",
    // State: "PR",
    // DistributionCenter: "San Juan",
    CitiesTowns: "SAN JUAN",
  },
  "010": {
    // Prefix: "010",
    // State: "MA",
    // DistributionCenter: "Springfield",
    CitiesTowns: "Amherest, Holyoke, Towns around Springfield",
  },
  "011": {
    // Prefix: "011",
    // State: "MA",
    // DistributionCenter: "Springfield",
    CitiesTowns: "SPRINGFIELD",
  },
  "012": {
    // Prefix: "012",
    // State: "MA",
    // DistributionCenter: "Pittsfield",
    CitiesTowns: "<i>Pittsfield</i>, North Adams, Berkshire County",
  },
  "013": {
    // Prefix: "013",
    // State: "MA",
    // DistributionCenter: "Springfield",
    CitiesTowns: "<i>Greenfield</i>, Athol, Franklin County",
  },
  "014": {
    // Prefix: "014",
    // State: "MA",
    // DistributionCenter: "Worcester",
    CitiesTowns: "<i>Fitchburg</i>, Garner",
  },
  "015": {
    // Prefix: "015",
    // State: "MA",
    // DistributionCenter: "Worcester",
    CitiesTowns: "Sturbridge, Auburn, Towns around Worcester",
  },
  "016": {
    // Prefix: "016",
    // State: "MA",
    // DistributionCenter: "Worcester",
    CitiesTowns: "WORCESTER",
  },
  "017": {
    // Prefix: "017",
    // State: "MA",
    // DistributionCenter: "Worcester",
    CitiesTowns: "<i>Framingham</i>, Concord, Western Boston exurbs,",
  },
  "018": {
    // Prefix: "018",
    // State: "MA",
    // DistributionCenter: "Middlesex-Essex",
    CitiesTowns: "Lowell, Woburn, Most of Middlesex County",
  },
  "019": {
    // Prefix: "019",
    // State: "MA",
    // DistributionCenter: "Middlesex-Essex",
    CitiesTowns: "Salem, <i>Lynn</i>, Gloucester, Essex County",
  },
  "020": {
    // Prefix: "020",
    // State: "MA",
    // DistributionCenter: "Brockton",
    CitiesTowns: "Dedham, Foxborough, Norfolk County",
  },
  "021": {
    // Prefix: "021",
    // State: "MA",
    // DistributionCenter: "Boston",
    CitiesTowns: "<i>Boston</i>, Cambridge",
  },
  "022": {
    // Prefix: "022",
    // State: "MA",
    // DistributionCenter: "Boston",
    CitiesTowns: "<i>Boston</i>, Quincy",
  },
  "023": {
    // Prefix: "023",
    // State: "MA",
    // DistributionCenter: "Brockton",
    CitiesTowns: "Brockton, Plymouth, Plymouth County",
  },
  "024": {
    // Prefix: "024",
    // State: "MA",
    // DistributionCenter: "NW Boston",
    CitiesTowns: "Brookline, Newton, Lexington, NW Boston Suburbs",
  },
  "025": {
    // Prefix: "025",
    // State: "MA",
    // DistributionCenter: "Cape Cod",
    CitiesTowns: "Buzzards Bay, Nantucket, Martha's Vineyard, West Cape Cod",
  },
  "026": {
    // Prefix: "026",
    // State: "MA",
    // DistributionCenter: "Cape Cod",
    CitiesTowns: "<i>Hyannis</i>, Provincetown, East Cape Cod",
  },
  "027": {
    // Prefix: "027",
    // State: "MA",
    // DistributionCenter: "Providence, RI",
    CitiesTowns: "New Bedford, Fall River, Bristol County",
  },
  "028": {
    // Prefix: "028",
    // State: "RI",
    // DistributionCenter: "Providence",
    CitiesTowns: "Newport, Westerly, Woonsocket, Most of Rhode Island",
  },
  "029": {
    // Prefix: "029",
    // State: "RI",
    // DistributionCenter: "Providence",
    CitiesTowns: "Providence, Cranston",
  },
  "030": {
    // Prefix: "030",
    // State: "NH",
    // DistributionCenter: "Manchester",
    CitiesTowns: "Nashua, Derry, Hillsborough County",
  },
  "031": {
    // Prefix: "031",
    // State: "NH",
    // DistributionCenter: "Manchester",
    CitiesTowns: "MANCHESTER",
  },
  "032": {
    // Prefix: "032",
    // State: "NH",
    // DistributionCenter: "Manchester",
    CitiesTowns: "Laconia, Plymouth, Areas around Concord",
  },
  "033": {
    // Prefix: "033",
    // State: "NH",
    // DistributionCenter: "Manchester",
    CitiesTowns: "CONCORD",
  },
  "034": {
    // Prefix: "034",
    // State: "NH",
    // DistributionCenter: "Manchester",
    CitiesTowns: "<i>Keene</i>, Jaffery, Chesire County",
  },
  "035": {
    // Prefix: "035",
    // State: "NH",
    // DistributionCenter: "White River Jct., VT",
    CitiesTowns: "<i>Littleton</i>, Berlin, Northern New Hampshire",
  },
  "036": {
    // Prefix: "036",
    // State: "NH",
    // DistributionCenter: "White River Jct., VT",
    CitiesTowns: "Charlestown, Walpole",
  },
  "037": {
    // Prefix: "037",
    // State: "NH",
    // DistributionCenter: "White River Jct., VT",
    CitiesTowns: "Lebanon, Woodsville, Western New Hampshire",
  },
  "038": {
    // Prefix: "038",
    // State: "NH",
    // DistributionCenter: "Portsmouth",
    CitiesTowns: "<i>Portsmouth</i>, Rochester, Conway",
  },
  "039": {
    // Prefix: "039",
    // State: "ME",
    // DistributionCenter: "Portsmouth, NH",
    CitiesTowns: "Kittery, York",
  },
  "040": {
    // Prefix: "040",
    // State: "ME",
    // DistributionCenter: "Portland",
    CitiesTowns: "Saco, Freeport, Towns around Portland",
  },
  "041": {
    // Prefix: "041",
    // State: "ME",
    // DistributionCenter: "Portland",
    CitiesTowns: "PORTLAND",
  },
  "042": {
    // Prefix: "042",
    // State: "ME",
    // DistributionCenter: "Portland",
    CitiesTowns: "Lewiston, <i>Auburn</i>, Rumford; Androscoggin and Oxford Counties",
  },
  "043": {
    // Prefix: "043",
    // State: "ME",
    // DistributionCenter: "Portland",
    CitiesTowns: "<i>Augusta</i>, Gardiner",
  },
  "044": {
    // Prefix: "044",
    // State: "ME",
    // DistributionCenter: "Bangor",
    CitiesTowns: "<i>Bangor</i>, Millinocket; Penobscot and Piscataquis Counties",
  },
  "045": {
    // Prefix: "045",
    // State: "ME",
    // DistributionCenter: "Portland",
    CitiesTowns: "<i>Bath</i>, Wiscasset; Lincoln and Sagadahoc Counties",
  },
  "046": {
    // Prefix: "046",
    // State: "ME",
    // DistributionCenter: "Bangor",
    CitiesTowns: "<i>Ellsworth</i>, Calais; Hancock and Washington Counties",
  },
  "047": {
    // Prefix: "047",
    // State: "ME",
    // DistributionCenter: "Bangor",
    CitiesTowns: "<i>Houlton</i>, Fort Kent; Aroostook County",
  },
  "048": {
    // Prefix: "048",
    // State: "ME",
    // DistributionCenter: "Portland",
    CitiesTowns: "<i>Rockland</i>, Camden",
  },
  "049": {
    // Prefix: "049",
    // State: "ME",
    // DistributionCenter: "Bangor",
    CitiesTowns: "<i>Waterville</i>, Farmington; Franklin Somerset and Waldo Counties",
  },
  "050": {
    // Prefix: "050",
    // State: "VT",
    // DistributionCenter: "White River Jct.",
    CitiesTowns: "<i>White River Junction</i>, Chelsea, Windsor County",
  },
  "051": {
    // Prefix: "051",
    // State: "VT",
    // DistributionCenter: "White River Jct.",
    CitiesTowns: "<i>Bellows Falls</i>, Ludlow, Springfield",
  },
  "052": {
    // Prefix: "052",
    // State: "VT",
    // DistributionCenter: "White River Jct.",
    CitiesTowns: "<i>Bennington</i>, Manchester, Bennington County",
  },
  "053": {
    // Prefix: "053",
    // State: "VT",
    // DistributionCenter: "White River Jct.",
    CitiesTowns: "<i>Brattleboro</i>, Wilmington",
  },
  "054": {
    // Prefix: "054",
    // State: "VT",
    // DistributionCenter: "Burlington",
    CitiesTowns: "<i>Burlington</i>, Saint Albans",
  },
  "055": {
    // Prefix: "055",
    // State: "MA",
    // DistributionCenter: "Middlesex-Essex",
    CitiesTowns: "IRS",
  },
  "056": {
    // Prefix: "056",
    // State: "VT",
    // DistributionCenter: "Burlington",
    CitiesTowns: "<i>Montpelier</i>, Morrisville; Lamoille and Washington Counties",
  },
  "057": {
    // Prefix: "057",
    // State: "VT",
    // DistributionCenter: "White River Jct.",
    CitiesTowns: "<i>Rutland</i>, Middlebury",
  },
  "058": {
    // Prefix: "058",
    // State: "VT",
    // DistributionCenter: "White River Jct.",
    CitiesTowns: "<i>St. Johnsbury</i>, Newport",
  },
  "059": {
    // Prefix: "059",
    // State: "VT",
    // DistributionCenter: "White River Jct.",
    CitiesTowns: "Guildhall, Averill, Essex County",
  },
  "060": {
    // Prefix: "060",
    // State: "CT",
    // DistributionCenter: "Hartford",
    CitiesTowns: "Bristol, Manchester, Areas around Hartford",
  },
  "061": {
    // Prefix: "061",
    // State: "CT",
    // DistributionCenter: "Hartford",
    CitiesTowns: "HARTFORD",
  },
  "062": {
    // Prefix: "062",
    // State: "CT",
    // DistributionCenter: "Hartford",
    CitiesTowns: "<i>Willimantic</i>, Storrs",
  },
  "063": {
    // Prefix: "063",
    // State: "CT",
    // DistributionCenter: "New Haven",
    CitiesTowns: "<i>New London</i>, Norwich",
  },
  "064": {
    // Prefix: "064",
    // State: "CT",
    // DistributionCenter: "New Haven",
    CitiesTowns: "Fairfield, Meridan, Areas around New Haven and Bridgeport",
  },
  "065": {
    // Prefix: "065",
    // State: "CT",
    // DistributionCenter: "New Haven",
    CitiesTowns: "NEW HAVEN",
  },
  "066": {
    // Prefix: "066",
    // State: "CT",
    // DistributionCenter: "New Haven",
    CitiesTowns: "BRIDGEPORT",
  },
  "067": {
    // Prefix: "067",
    // State: "CT",
    // DistributionCenter: "Waterbury",
    CitiesTowns: "Waterbury, Torrington",
  },
  "068": {
    // Prefix: "068",
    // State: "CT",
    // DistributionCenter: "Stamford",
    CitiesTowns: "Danbury, Norwalk, Southwestern Connecticut",
  },
  "069": {
    // Prefix: "069",
    // State: "CT",
    // DistributionCenter: "Stamford",
    CitiesTowns: "STAMFORD",
  },
  "070": {
    // Prefix: "070",
    // State: "NJ",
    // DistributionCenter: "Newark",
    CitiesTowns: "Hoboken, Plainfield, Areas around Newark, Jersey City, Elizabeth",
  },
  "071": {
    // Prefix: "071",
    // State: "NJ",
    // DistributionCenter: "Newark",
    CitiesTowns: "NEWARK",
  },
  "072": {
    // Prefix: "072",
    // State: "NJ",
    // DistributionCenter: "Newark",
    CitiesTowns: "JERSEY CITY",
  },
  "073": {
    // Prefix: "073",
    // State: "NJ",
    // DistributionCenter: "Newark",
    CitiesTowns: "ELIZABETH",
  },
  "074": {
    // Prefix: "074",
    // State: "NJ",
    // DistributionCenter: "Paterson",
    CitiesTowns: "Wayne, Ramsey, Areas around Paterson",
  },
  "075": {
    // Prefix: "075",
    // State: "NJ",
    // DistributionCenter: "Paterson",
    CitiesTowns: "PATERSON",
  },
  "076": {
    // Prefix: "076",
    // State: "NJ",
    // DistributionCenter: "Hackensack",
    CitiesTowns: "<i>Hackensack</i>, Paramus",
  },
  "077": {
    // Prefix: "077",
    // State: "NJ",
    // DistributionCenter: "Monmouth",
    CitiesTowns: "<i>Red Bank<i>, Long Branch, Freehold, Monmouth County",
  },
  "078": {
    // Prefix: "078",
    // State: "NJ",
    // DistributionCenter: "West Jersey",
    CitiesTowns: "Phillipsburg, <i>Dover</i>",
  },
  "079": {
    // Prefix: "079",
    // State: "NJ",
    // DistributionCenter: "West Jersey",
    CitiesTowns: "Morristown, <i>Summit</i>",
  },
  "080": {
    // Prefix: "080",
    // State: "NJ",
    // DistributionCenter: "South Jersey",
    CitiesTowns: "Burlington, Cherry Hill, Areas around Camden",
  },
  "081": {
    // Prefix: "081",
    // State: "NJ",
    // DistributionCenter: "South Jersey",
    CitiesTowns: "CAMDEN",
  },
  "082": {
    // Prefix: "082",
    // State: "NJ",
    // DistributionCenter: "South Jersey",
    CitiesTowns: "Cape May, Ocean City, Areas around Atlantic City",
  },
  "083": {
    // Prefix: "083",
    // State: "NJ",
    // DistributionCenter: "South Jersey",
    CitiesTowns: "Vineland, Millville, <i>Bridgeton</i>, Cumberland County",
  },
  "084": {
    // Prefix: "084",
    // State: "NJ",
    // DistributionCenter: "South Jersey",
    CitiesTowns: "ATLANTIC CITY",
  },
  "085": {
    // Prefix: "085",
    // State: "NJ",
    // DistributionCenter: "Trenton",
    CitiesTowns: "Princeton, Bordentown, Areas around Trenton",
  },
  "086": {
    // Prefix: "086",
    // State: "NJ",
    // DistributionCenter: "Trenton",
    CitiesTowns: "TRENTON",
  },
  "087": {
    // Prefix: "087",
    // State: "NJ",
    // DistributionCenter: "Monmouth",
    CitiesTowns: "Lakewood, Toms River, Ocean County",
  },
  "088": {
    // Prefix: "088",
    // State: "NJ",
    // DistributionCenter: "Kilmer",
    CitiesTowns: "Edison, Perth Amboy, Areas around New Brunswick",
  },
  "089": {
    // Prefix: "089",
    // State: "NJ",
    // DistributionCenter: "Kilmer",
    CitiesTowns: "NEW BRUNSWICK",
  },
  "090": {
    // Prefix: "090",
    // State: "AE",
    // DistributionCenter: "New York, NY",
    CitiesTowns: "Bases in Germany",
  },
  "091": {
    // Prefix: "091",
    // State: "AE",
    // DistributionCenter: "New York, NY",
    CitiesTowns: "Bases in Germany",
  },
  "092": {
    // Prefix: "092",
    // State: "AE",
    // DistributionCenter: "New York, NY",
    CitiesTowns: "Bases in Germany",
  },
  "093": {
    // Prefix: "093",
    // State: "AE",
    // DistributionCenter: "New York, NY",
    CitiesTowns: "Special Ops., Army Bases in Iraq and Afghanistan",
  },
  "094": {
    // Prefix: "094",
    // State: "AE",
    // DistributionCenter: "New York, NY",
    CitiesTowns: "Bases in the United Kingdom",
  },
  "095": {
    // Prefix: "095",
    // State: "AE",
    // DistributionCenter: "New York, NY",
    CitiesTowns: "Ships/Naval Bases in Atlantic Ocean",
  },
  "096": {
    // Prefix: "096",
    // State: "AE",
    // DistributionCenter: "New York, NY",
    CitiesTowns: "Bases in Italy and Eastern Europe",
  },
  "097": {
    // Prefix: "097",
    // State: "AE",
    // DistributionCenter: "New York, NY",
    CitiesTowns: "Bases for NATO, EU, Greenland, Canada",
  },
  "098": {
    // Prefix: "098",
    // State: "AE",
    // DistributionCenter: "New York, NY",
    CitiesTowns: "Bases in Africa and Middle East",
  },
  "099": {
    // Prefix: "099",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "100": {
    // Prefix: "100",
    // State: "NY",
    // DistributionCenter: "New York City",
    CitiesTowns: "NEW YORK CITY (Manhattan)",
  },
  "101": {
    // Prefix: "101",
    // State: "NY",
    // DistributionCenter: "New York City",
    CitiesTowns: "NEW YORK CITY (Manhattan)",
  },
  "102": {
    // Prefix: "102",
    // State: "NY",
    // DistributionCenter: "New York City",
    CitiesTowns: "NEW YORK CITY (Manhattan)",
  },
  "103": {
    // Prefix: "103",
    // State: "NY",
    // DistributionCenter: "Staten Island",
    CitiesTowns: "New York City (STATEN ISLAND)",
  },
  "104": {
    // Prefix: "104",
    // State: "NY",
    // DistributionCenter: "Bronx",
    CitiesTowns: "New York City (BRONX)",
  },
  "105": {
    // Prefix: "105",
    // State: "NY",
    // DistributionCenter: "Westchester",
    CitiesTowns: "Croton, Mount Vernon, Westchester County",
  },
  "106": {
    // Prefix: "106",
    // State: "NY",
    // DistributionCenter: "Westchester",
    CitiesTowns: "WHITE PLAINS",
  },
  "107": {
    // Prefix: "107",
    // State: "NY",
    // DistributionCenter: "Westchester",
    CitiesTowns: "YONKERS",
  },
  "108": {
    // Prefix: "108",
    // State: "NY",
    // DistributionCenter: "Westchester",
    CitiesTowns: "NEW ROCHELLE",
  },
  "109": {
    // Prefix: "109",
    // State: "NY",
    // DistributionCenter: "Rockland",
    CitiesTowns: "Nyack, Middletown, <i>Suffern</i>, Rockland Counties",
  },
  "110": {
    // Prefix: "110",
    // State: "NY",
    // DistributionCenter: "Queens",
    CitiesTowns: "Elmont, Great Neck, <i>Floral Park</i>",
  },
  "111": {
    // Prefix: "111",
    // State: "NY",
    // DistributionCenter: "Queens",
    CitiesTowns: "New York City (LONG ISLAND CITY, Queens)",
  },
  "112": {
    // Prefix: "112",
    // State: "NY",
    // DistributionCenter: "Brooklyn",
    CitiesTowns: "New York City (BROOKLYN)",
  },
  "113": {
    // Prefix: "113",
    // State: "NY",
    // DistributionCenter: "Queens",
    CitiesTowns: "New York City (FLUSHING, Queens)",
  },
  "114": {
    // Prefix: "114",
    // State: "NY",
    // DistributionCenter: "Queens",
    CitiesTowns: "New York City (JAMAICA, Queens)",
  },
  "115": {
    // Prefix: "115",
    // State: "NY",
    // DistributionCenter: "W. Nassau",
    CitiesTowns: "Hempstead, <i>Minneola</i>",
  },
  "116": {
    // Prefix: "116",
    // State: "NY",
    // DistributionCenter: "Queens",
    CitiesTowns: "New York City (FAR ROCKAWAY, Queens)",
  },
  "117": {
    // Prefix: "117",
    // State: "NY",
    // DistributionCenter: "Mid-Island",
    CitiesTowns: "Commack, Babylon",
  },
  "118": {
    // Prefix: "118",
    // State: "NY",
    // DistributionCenter: "Mid-Island",
    CitiesTowns: "HICKSVILLE",
  },
  "119": {
    // Prefix: "119",
    // State: "NY",
    // DistributionCenter: "Mid-Island",
    CitiesTowns: "<i>Riverhead</i>, The Hamptons",
  },
  "120": {
    // Prefix: "120",
    // State: "NY",
    // DistributionCenter: "Albany",
    CitiesTowns: "Amsterdam, Cohoes, Towns around Albany A-J",
  },
  "121": {
    // Prefix: "121",
    // State: "NY",
    // DistributionCenter: "Albany",
    CitiesTowns: "Troy, Rotterdam, Towns around Albany K-Z",
  },
  "122": {
    // Prefix: "122",
    // State: "NY",
    // DistributionCenter: "Albany",
    CitiesTowns: "ALBANY",
  },
  "123": {
    // Prefix: "123",
    // State: "NY",
    // DistributionCenter: "Albany",
    CitiesTowns: "SCHENECTADY",
  },
  "124": {
    // Prefix: "124",
    // State: "NY",
    // DistributionCenter: "Mid-Hudson",
    CitiesTowns: "<i>Kingston</i>, Catskill",
  },
  "125": {
    // Prefix: "125",
    // State: "NY",
    // DistributionCenter: "Mid-Hudson",
    CitiesTowns: "Newburgh, Hudson, Towns around Poughkeepsie",
  },
  "126": {
    // Prefix: "126",
    // State: "NY",
    // DistributionCenter: "Mid-Hudson",
    CitiesTowns: "POUGHKEEPSIE",
  },
  "127": {
    // Prefix: "127",
    // State: "NY",
    // DistributionCenter: "Mid-Hudson",
    CitiesTowns: "<i>Monticello</i>, Port Jervis",
  },
  "128": {
    // Prefix: "128",
    // State: "NY",
    // DistributionCenter: "Glens Falls",
    CitiesTowns: "<i>Glens Falls</i>, Saratoga Springs",
  },
  "129": {
    // Prefix: "129",
    // State: "NY",
    // DistributionCenter: "Plattsburgh",
    CitiesTowns: "<i>Plattsburgh</i>, Lake Placid",
  },
  "130": {
    // Prefix: "130",
    // State: "NY",
    // DistributionCenter: "Syracuse",
    CitiesTowns: "Auburn, Cortland, Towns around Syracuse A-L",
  },
  "131": {
    // Prefix: "131",
    // State: "NY",
    // DistributionCenter: "Syracuse",
    CitiesTowns: "Oswego, Wampsville, Towns around Syracuse M-Z",
  },
  "132": {
    // Prefix: "132",
    // State: "NY",
    // DistributionCenter: "Syracuse",
    CitiesTowns: "SYRACUSE",
  },
  "133": {
    // Prefix: "133",
    // State: "NY",
    // DistributionCenter: "Utica",
    CitiesTowns: "Cooperstown, Herkimer, Towns around Utica A-J",
  },
  "134": {
    // Prefix: "134",
    // State: "NY",
    // DistributionCenter: "Utica",
    CitiesTowns: "Rome, Waterville, Towns around Utica K-Z",
  },
  "135": {
    // Prefix: "135",
    // State: "NY",
    // DistributionCenter: "Utica",
    CitiesTowns: "UTICA",
  },
  "136": {
    // Prefix: "136",
    // State: "NY",
    // DistributionCenter: "Watertown",
    CitiesTowns: "Watertown, Potsdam",
  },
  "137": {
    // Prefix: "137",
    // State: "NY",
    // DistributionCenter: "Binghamton",
    CitiesTowns: "Johnson City, Endicott, Towns around Binghamton A-L",
  },
  "138": {
    // Prefix: "138",
    // State: "NY",
    // DistributionCenter: "Binghamton",
    CitiesTowns: "Oneonta, Norwich, Towns around Binghamton M-Z",
  },
  "139": {
    // Prefix: "139",
    // State: "NY",
    // DistributionCenter: "Binghamton",
    CitiesTowns: "BINGHAMTON",
  },
  "140": {
    // Prefix: "140",
    // State: "NY",
    // DistributionCenter: "Buffalo",
    CitiesTowns: "Batavia, Dunkirk, Towns around Buffalo A-L",
  },
  "141": {
    // Prefix: "141",
    // State: "NY",
    // DistributionCenter: "Buffalo",
    CitiesTowns: "Tonawanda, Medina, Towns around Buffalo M-Z",
  },
  "142": {
    // Prefix: "142",
    // State: "NY",
    // DistributionCenter: "Buffalo",
    CitiesTowns: "BUFFALO",
  },
  "143": {
    // Prefix: "143",
    // State: "NY",
    // DistributionCenter: "Buffalo",
    CitiesTowns: "NIAGARA FALLS",
  },
  "144": {
    // Prefix: "144",
    // State: "NY",
    // DistributionCenter: "Rochester",
    CitiesTowns: "Genesco, Canandaigua, Towns around Rochester A-L",
  },
  "145": {
    // Prefix: "145",
    // State: "NY",
    // DistributionCenter: "Rochester",
    CitiesTowns: "Penn Yan, Newark, Towns around Rochester M-Z",
  },
  "146": {
    // Prefix: "146",
    // State: "NY",
    // DistributionCenter: "Rochester",
    CitiesTowns: "ROCHESTER",
  },
  "147": {
    // Prefix: "147",
    // State: "NY",
    // DistributionCenter: "Jamestown",
    CitiesTowns: "<i>Jamestown</i>, Olean",
  },
  "148": {
    // Prefix: "148",
    // State: "NY",
    // DistributionCenter: "Elmira",
    CitiesTowns: "Ithaca, Corning",
  },
  "149": {
    // Prefix: "149",
    // State: "NY",
    // DistributionCenter: "Elmira",
    CitiesTowns: "ELMIRA",
  },
  "150": {
    // Prefix: "150",
    // State: "PA",
    // DistributionCenter: "Pittsburgh",
    CitiesTowns: "Beaver, Warrendale, Towns around Pittsburgh",
  },
  "151": {
    // Prefix: "151",
    // State: "PA",
    // DistributionCenter: "Pittsburgh",
    CitiesTowns: "McKeesport, West Mifflin, Towns around Pittsburgh",
  },
  "152": {
    // Prefix: "152",
    // State: "PA",
    // DistributionCenter: "Pittsburgh",
    CitiesTowns: "PITTSBURGH",
  },
  "153": {
    // Prefix: "153",
    // State: "PA",
    // DistributionCenter: "Pittsburgh",
    CitiesTowns: "<i>Washington</i>, Waynesburg; Greene and Washington Counties",
  },
  "154": {
    // Prefix: "154",
    // State: "PA",
    // DistributionCenter: "Pittsburgh",
    CitiesTowns: "<i>Uniontown</i>, Connellsville, Fayette County",
  },
  "155": {
    // Prefix: "155",
    // State: "PA",
    // DistributionCenter: "Johnstown",
    CitiesTowns: "<i>Somerset</i>, Bedford",
  },
  "156": {
    // Prefix: "156",
    // State: "PA",
    // DistributionCenter: "Greensburg",
    CitiesTowns: "<i>Greensburg</i>, Latrobe; Westmoreland County",
  },
  "157": {
    // Prefix: "157",
    // State: "PA",
    // DistributionCenter: "Johnstown",
    CitiesTowns: "<i>Indiana</i>, Punxsutawney",
  },
  "158": {
    // Prefix: "158",
    // State: "PA",
    // DistributionCenter: "DuBois",
    CitiesTowns: "<i>DuBois</i>, Saint Marys",
  },
  "159": {
    // Prefix: "159",
    // State: "PA",
    // DistributionCenter: "Johnstown",
    CitiesTowns: "<i>Johnstown</i>, Ebensburg",
  },
  "160": {
    // Prefix: "160",
    // State: "PA",
    // DistributionCenter: "New Castle",
    CitiesTowns: "<i>Butler</i>, Slippery Rock; Butler County",
  },
  "161": {
    // Prefix: "161",
    // State: "PA",
    // DistributionCenter: "New Castle",
    CitiesTowns: "<i>New Castle</i>, Sharon; Lawrence and Mercer Counties",
  },
  "162": {
    // Prefix: "162",
    // State: "PA",
    // DistributionCenter: "New Castle",
    CitiesTowns: "Clarion, <i>Kittanning</i>",
  },
  "163": {
    // Prefix: "163",
    // State: "PA",
    // DistributionCenter: "Oil City",
    CitiesTowns: "<i>Oil City</i>, Warren",
  },
  "164": {
    // Prefix: "164",
    // State: "PA",
    // DistributionCenter: "Erie",
    CitiesTowns: "Edinboro, North East, Towns around Erie",
  },
  "165": {
    // Prefix: "165",
    // State: "PA",
    // DistributionCenter: "Erie",
    CitiesTowns: "ERIE",
  },
  "166": {
    // Prefix: "166",
    // State: "PA",
    // DistributionCenter: "Altoona",
    CitiesTowns: "<i>Altoona</i>, Tyrone",
  },
  "167": {
    // Prefix: "167",
    // State: "PA",
    // DistributionCenter: "Bradford",
    CitiesTowns: "<i>Bradford</i>, Mount Jewett, McKean County",
  },
  "168": {
    // Prefix: "168",
    // State: "PA",
    // DistributionCenter: "Altoona",
    CitiesTowns: "<i>State College</i>, Clearfield",
  },
  "169": {
    // Prefix: "169",
    // State: "PA",
    // DistributionCenter: "Williamsport",
    CitiesTowns: "<i>Wellsboro</i>, Coudersport",
  },
  "170": {
    // Prefix: "170",
    // State: "PA",
    // DistributionCenter: "Harrisburg",
    CitiesTowns: "Carlisle, Hershey, Towns around Harrisburg",
  },
  "171": {
    // Prefix: "171",
    // State: "PA",
    // DistributionCenter: "Harrisburg",
    CitiesTowns: "HARRISBURG",
  },
  "172": {
    // Prefix: "172",
    // State: "PA",
    // DistributionCenter: "Harrisburg",
    CitiesTowns: "<i>Chambersburg</i>, Waynesboro",
  },
  "173": {
    // Prefix: "173",
    // State: "PA",
    // DistributionCenter: "Lancaster",
    CitiesTowns: "Gettysburg, Red Lion, Towns around York",
  },
  "174": {
    // Prefix: "174",
    // State: "PA",
    // DistributionCenter: "Lancaster",
    CitiesTowns: "YORK",
  },
  "175": {
    // Prefix: "175",
    // State: "PA",
    // DistributionCenter: "Lancaster",
    CitiesTowns: "Paradise, Areas in Lancaster County and around Lancaster",
  },
  "176": {
    // Prefix: "176",
    // State: "PA",
    // DistributionCenter: "Lancaster",
    CitiesTowns: "LANCASTER",
  },
  "177": {
    // Prefix: "177",
    // State: "PA",
    // DistributionCenter: "Williamsport",
    CitiesTowns: "<i>Williamsport</i>",
  },
  "178": {
    // Prefix: "178",
    // State: "PA",
    // DistributionCenter: "Harrisburg",
    CitiesTowns: "<i>Sunbury</i>, Bloomsburg",
  },
  "179": {
    // Prefix: "179",
    // State: "PA",
    // DistributionCenter: "Reading",
    CitiesTowns: "<i>Pottsville</i>, Mahanoy City, Schuylkill County",
  },
  "180": {
    // Prefix: "180",
    // State: "PA",
    // DistributionCenter: "Lehigh Valley",
    CitiesTowns: "Easton, Bethlehem, Areas around Allentown",
  },
  "181": {
    // Prefix: "181",
    // State: "PA",
    // DistributionCenter: "Lehigh Valley",
    CitiesTowns: "ALLENTOWN",
  },
  "182": {
    // Prefix: "182",
    // State: "PA",
    // DistributionCenter: "Wilkes-Barre",
    CitiesTowns: "<i>Hazelton</i>, Jim Thorpe",
  },
  "183": {
    // Prefix: "183",
    // State: "PA",
    // DistributionCenter: "Lehigh Valley",
    CitiesTowns: "Stroudsburg, Milford, <i>East Stroudsburg</i>",
  },
  "184": {
    // Prefix: "184",
    // State: "PA",
    // DistributionCenter: "Scranton",
    CitiesTowns: "Carbondale, Hawley, Areas around Scranton",
  },
  "185": {
    // Prefix: "185",
    // State: "PA",
    // DistributionCenter: "Scranton",
    CitiesTowns: "SCRANTON",
  },
  "186": {
    // Prefix: "186",
    // State: "PA",
    // DistributionCenter: "Wilkes-Barre",
    CitiesTowns: "Blakeslee, Nanticoke, Areas around Wilkes-Barre",
  },
  "187": {
    // Prefix: "187",
    // State: "PA",
    // DistributionCenter: "Wilkes-Barre",
    CitiesTowns: "WILKES-BARRE",
  },
  "188": {
    // Prefix: "188",
    // State: "PA",
    // DistributionCenter: "Scranton",
    CitiesTowns: "Towanda, <i>Montrose</i>",
  },
  "189": {
    // Prefix: "189",
    // State: "PA",
    // DistributionCenter: "Southeastern",
    CitiesTowns: "<i>Doylestown</i>, Quakertown",
  },
  "190": {
    // Prefix: "190",
    // State: "PA",
    // DistributionCenter: "Philadelphia",
    CitiesTowns: "Chester, Levittown, Areas around Philadelphia",
  },
  "191": {
    // Prefix: "191",
    // State: "PA",
    // DistributionCenter: "Philadelphia",
    CitiesTowns: "PHILADELPHIA",
  },
  "192": {
    // Prefix: "192",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "193": {
    // Prefix: "193",
    // State: "PA",
    // DistributionCenter: "Southeastern",
    CitiesTowns: "<i>Paoli</i>, West Chester, Chester County",
  },
  "194": {
    // Prefix: "194",
    // State: "PA",
    // DistributionCenter: "Southeastern",
    CitiesTowns: "<i>Norristown</i>, Pottstown",
  },
  "195": {
    // Prefix: "195",
    // State: "PA",
    // DistributionCenter: "Reading",
    CitiesTowns: "Kutztown, Hamburg, Areas in Berks County around Reading",
  },
  "196": {
    // Prefix: "196",
    // State: "PA",
    // DistributionCenter: "Reading",
    CitiesTowns: "READING",
  },
  "197": {
    // Prefix: "197",
    // State: "DE",
    // DistributionCenter: "Wilmington",
    CitiesTowns: "Newark, New Castle, Areas in New Castle County around Wilmington",
  },
  "198": {
    // Prefix: "198",
    // State: "DE",
    // DistributionCenter: "Wilmington",
    CitiesTowns: "WILMINGTON",
  },
  "199": {
    // Prefix: "199",
    // State: "DE",
    // DistributionCenter: "Wilmington",
    CitiesTowns: "<i>Dover</i>, Georgetown, Kent and Sussex Counties",
  },
  "200": {
    // Prefix: "200",
    // State: "DC",
    // DistributionCenter: "Washington",
    CitiesTowns: "WASHINGTON",
  },
  "201": {
    // Prefix: "201",
    // State: "VA",
    // DistributionCenter: "Dulles",
    CitiesTowns: "Mannassas, Leesburg",
  },
  "202": {
    // Prefix: "202",
    // State: "DC",
    // DistributionCenter: "Washington",
    CitiesTowns: "U.S. Government",
  },
  "203": {
    // Prefix: "203",
    // State: "DC",
    // DistributionCenter: "Washington",
    CitiesTowns: "U.S. Government",
  },
  "204": {
    // Prefix: "204",
    // State: "DC",
    // DistributionCenter: "Washington",
    CitiesTowns: "U.S. Government",
  },
  "205": {
    // Prefix: "205",
    // State: "DC",
    // DistributionCenter: "Washington",
    CitiesTowns: "U.S. Government",
  },
  "206": {
    // Prefix: "206",
    // State: "MD",
    // DistributionCenter: "Southern",
    CitiesTowns: "Lexington Park, <i>Waldorf</i>",
  },
  "207": {
    // Prefix: "207",
    // State: "MD",
    // DistributionCenter: "Southern",
    CitiesTowns: "College Park, Bowie, Capitol Heights",
  },
  "208": {
    // Prefix: "208",
    // State: "MD",
    // DistributionCenter: "Suburban",
    CitiesTowns: "Rockville, Bethesda",
  },
  "209": {
    // Prefix: "209",
    // State: "MD",
    // DistributionCenter: "Suburban",
    CitiesTowns: "SILVER SPRING",
  },
  "210": {
    // Prefix: "210",
    // State: "MD",
    // DistributionCenter: "Linthicum",
    CitiesTowns: "Aberdeen, Columbia, Areas around Baltimore A-L",
  },
  "211": {
    // Prefix: "211",
    // State: "MD",
    // DistributionCenter: "Linthicum",
    CitiesTowns: "Westminster, Pasadena",
  },
  "212": {
    // Prefix: "212",
    // State: "MD",
    // DistributionCenter: "Baltimore",
    CitiesTowns: "BALTIMORE",
  },
  "213": {
    // Prefix: "213",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "214": {
    // Prefix: "214",
    // State: "MD",
    // DistributionCenter: "Linthicum",
    CitiesTowns: "ANNAPOLIS",
  },
  "215": {
    // Prefix: "215",
    // State: "MD",
    // DistributionCenter: "Cumberland",
    CitiesTowns: "<i>Cumberland</i>, Oakland; Allegany and Garrett Counties",
  },
  "216": {
    // Prefix: "216",
    // State: "MD",
    // DistributionCenter: "Easton",
    CitiesTowns: "<i>Easton</i>, Cambridge",
  },
  "217": {
    // Prefix: "217",
    // State: "MD",
    // DistributionCenter: "Frederick",
    CitiesTowns: "<i>Frederick</i>, Hagerstown",
  },
  "218": {
    // Prefix: "218",
    // State: "MD",
    // DistributionCenter: "Salisbury",
    CitiesTowns: "<i>Salisbury</i>, Ocean City, Pocomoke City",
  },
  "219": {
    // Prefix: "219",
    // State: "MD",
    // DistributionCenter: "Baltimore",
    CitiesTowns: "Elkton, <i>North East</i>, Cecilton",
  },
  "220": {
    // Prefix: "220",
    // State: "VA",
    // DistributionCenter: "Northern VA",
    CitiesTowns: "Falls Church, Fairfax, DC Suburbs A-L",
  },
  "221": {
    // Prefix: "221",
    // State: "VA",
    // DistributionCenter: "Northern VA",
    CitiesTowns: "Woodbridge, McLean, DC Suburbs M-Z",
  },
  "222": {
    // Prefix: "222",
    // State: "VA",
    // DistributionCenter: "Northern VA",
    CitiesTowns: "ARLINGTON",
  },
  "223": {
    // Prefix: "223",
    // State: "VA",
    // DistributionCenter: "Northern VA",
    CitiesTowns: "ALEXANDRIA",
  },
  "224": {
    // Prefix: "224",
    // State: "VA",
    // DistributionCenter: "Richmond",
    CitiesTowns: "<i>Fredericksburg, Heathsville, East Central VA A-L</i>",
  },
  "225": {
    // Prefix: "225",
    // State: "VA",
    // DistributionCenter: "Richmond",
    CitiesTowns: "Tappahannock, Spotsylvania, East Central VA A-L",
  },
  "226": {
    // Prefix: "226",
    // State: "VA",
    // DistributionCenter: "Winchester",
    CitiesTowns: "<i>Winchester</i>, Front Royal",
  },
  "227": {
    // Prefix: "227",
    // State: "VA",
    // DistributionCenter: "Culpeper",
    CitiesTowns: "<i>Culpeper</i>, Washington",
  },
  "228": {
    // Prefix: "228",
    // State: "VA",
    // DistributionCenter: "Charlottesville",
    CitiesTowns: "<i>Harrisonburg</i>, Luray",
  },
  "229": {
    // Prefix: "229",
    // State: "VA",
    // DistributionCenter: "Charlottesville",
    CitiesTowns: "<i>Charlottesville</i>, Waynesboro",
  },
  "230": {
    // Prefix: "230",
    // State: "VA",
    // DistributionCenter: "Richmond",
    CitiesTowns: "Ashland, Gloucester, Areas around Richmond A-L",
  },
  "231": {
    // Prefix: "231",
    // State: "VA",
    // DistributionCenter: "Richmond",
    CitiesTowns: "Williamsburg, Powhatan, Areas around Richmond M-Z",
  },
  "232": {
    // Prefix: "232",
    // State: "VA",
    // DistributionCenter: "Richmond",
    CitiesTowns: "RICHMOND",
  },
  "233": {
    // Prefix: "233",
    // State: "VA",
    // DistributionCenter: "Norfolk",
    CitiesTowns: "Chesapeake, Emporia, Delmarva Peninsula and Areas around Norfolk A-J",
  },
  "234": {
    // Prefix: "234",
    // State: "VA",
    // DistributionCenter: "Norfolk",
    CitiesTowns: "Virginia Beach, Melfa, Delmarva Peninsula and Areas around Norfolk A-J",
  },
  "235": {
    // Prefix: "235",
    // State: "VA",
    // DistributionCenter: "Norfolk",
    CitiesTowns: "NORFOLK",
  },
  "236": {
    // Prefix: "236",
    // State: "VA",
    // DistributionCenter: "Norfolk",
    CitiesTowns: "Newport News, Hampton, Yorktown",
  },
  "237": {
    // Prefix: "237",
    // State: "VA",
    // DistributionCenter: "Norfolk",
    CitiesTowns: "PORTSMOUTH",
  },
  "238": {
    // Prefix: "238",
    // State: "VA",
    // DistributionCenter: "Richmond",
    CitiesTowns: "<i>Petersburg</i>, Emporia, Franklin",
  },
  "239": {
    // Prefix: "239",
    // State: "VA",
    // DistributionCenter: "Farmville",
    CitiesTowns: "<i>Farmville</i>, South Hill",
  },
  "240": {
    // Prefix: "240",
    // State: "VA",
    // DistributionCenter: "Roanoke",
    CitiesTowns: "<i>Roanoke</i>, Blacksburg, Areas around Roanoke A-G",
  },
  "241": {
    // Prefix: "241",
    // State: "VA",
    // DistributionCenter: "Roanoke",
    CitiesTowns: "Martinsville, Radford, Areas around Roanoke L-Z",
  },
  "242": {
    // Prefix: "242",
    // State: "VA",
    // DistributionCenter: "Bristol",
    CitiesTowns: "<i>Bristol</i>, Wise",
  },
  "243": {
    // Prefix: "243",
    // State: "VA",
    // DistributionCenter: "Roanoke",
    CitiesTowns: "<i>Pulaski</i>, Wytheville",
  },
  "244": {
    // Prefix: "244",
    // State: "VA",
    // DistributionCenter: "Charlottesville",
    CitiesTowns: "<i>Staunton</i>, Covington",
  },
  "245": {
    // Prefix: "245",
    // State: "VA",
    // DistributionCenter: "Lynchburg",
    CitiesTowns: "<i>Lynchburg</i>, Danville",
  },
  "246": {
    // Prefix: "246",
    // State: "VA",
    // DistributionCenter: "Bluefield, WV",
    CitiesTowns: "Bluefield, Grundy",
  },
  "247": {
    // Prefix: "247",
    // State: "WV",
    // DistributionCenter: "Bluefield",
    CitiesTowns: "<i>Bluefield</i>, Princeton; Mercer County",
  },
  "248": {
    // Prefix: "248",
    // State: "WV",
    // DistributionCenter: "Bluefield",
    CitiesTowns: "<i>Welch</i>, Pineville; McDowell and Wyoming Counties",
  },
  "249": {
    // Prefix: "249",
    // State: "WV",
    // DistributionCenter: "Lewisburg",
    CitiesTowns: "<i>Lewisburg</i>, Marlinton, Union",
  },
  "250": {
    // Prefix: "250",
    // State: "WV",
    // DistributionCenter: "Charleston",
    CitiesTowns: "Dunbar, Cedar Grove",
  },
  "251": {
    // Prefix: "251",
    // State: "WV",
    // DistributionCenter: "Charleston",
    CitiesTowns: "Nitro, Madison, Areas around Charleston H-S",
  },
  "252": {
    // Prefix: "252",
    // State: "WV",
    // DistributionCenter: "Charleston",
    CitiesTowns: "Ripley, Spencer, Areas to north of Charleston, areas around Charleston T-Z",
  },
  "253": {
    // Prefix: "253",
    // State: "WV",
    // DistributionCenter: "Charleston",
    CitiesTowns: "CHARLESTON",
  },
  "254": {
    // Prefix: "254",
    // State: "WV",
    // DistributionCenter: "Martinsburg",
    CitiesTowns: "Martinsburg, Harper’s Ferry",
  },
  "255": {
    // Prefix: "255",
    // State: "WV",
    // DistributionCenter: "Huntington",
    CitiesTowns: "Point Pleasant, Barbourville, Areas around Huntington",
  },
  "256": {
    // Prefix: "256",
    // State: "WV",
    // DistributionCenter: "Huntington",
    CitiesTowns: "<i>Logan</i>, Williamson; Logan and Mingo Counties",
  },
  "257": {
    // Prefix: "257",
    // State: "WV",
    // DistributionCenter: "Huntington",
    CitiesTowns: "HUNTINGTON",
  },
  "258": {
    // Prefix: "258",
    // State: "WV",
    // DistributionCenter: "Beckley",
    CitiesTowns: "<i>Beckley</i>, Fayetteville; Areas around Beckley A-L",
  },
  "259": {
    // Prefix: "259",
    // State: "WV",
    // DistributionCenter: "Beckley",
    CitiesTowns: "Oak Hill, Sprague; Areas around Beckley M-Z",
  },
  "260": {
    // Prefix: "260",
    // State: "WV",
    // DistributionCenter: "Wheeling",
    CitiesTowns: "<i>Wheeling</i>, Weirton",
  },
  "261": {
    // Prefix: "261",
    // State: "WV",
    // DistributionCenter: "Parkersburg",
    CitiesTowns: "<i>Parkersburg</i>, New Martinsville",
  },
  "262": {
    // Prefix: "262",
    // State: "WV",
    // DistributionCenter: "Clarksburg",
    CitiesTowns: "<i>Buckhannon</i>, Elkins",
  },
  "263": {
    // Prefix: "263",
    // State: "WV",
    // DistributionCenter: "Clarksburg",
    CitiesTowns: "<i>Clarksburg</i>, Grafton, Areas around Clarksburg A-L",
  },
  "264": {
    // Prefix: "264",
    // State: "WV",
    // DistributionCenter: "Clarksburg",
    CitiesTowns: "Philippi, Weston, Areas around Clarksburg M-Z",
  },
  "265": {
    // Prefix: "265",
    // State: "WV",
    // DistributionCenter: "Clarksburg",
    CitiesTowns: "<i>Morganton</i>, Fairmont",
  },
  "266": {
    // Prefix: "266",
    // State: "WV",
    // DistributionCenter: "Gassaway",
    CitiesTowns: "<i>Sutton</i>, Summersville",
  },
  "267": {
    // Prefix: "267",
    // State: "WV",
    // DistributionCenter: "Cumberland, MD",
    CitiesTowns: "Keyser, Romney",
  },
  "268": {
    // Prefix: "268",
    // State: "WV",
    // DistributionCenter: "Petersburg",
    CitiesTowns: "Petersburg, Franklin",
  },
  "269": {
    // Prefix: "269",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "270": {
    // Prefix: "270",
    // State: "NC",
    // DistributionCenter: "Greensboro",
    CitiesTowns: "Clemmons, Mount Airy, Towns around Winston-Salem",
  },
  "271": {
    // Prefix: "271",
    // State: "NC",
    // DistributionCenter: "Greensboro",
    CitiesTowns: "WINSTON-SALEM",
  },
  "272": {
    // Prefix: "272",
    // State: "NC",
    // DistributionCenter: "Greensboro",
    CitiesTowns: "Burlington, Asheboro, Towns around Greensboro A-L",
  },
  "273": {
    // Prefix: "273",
    // State: "NC",
    // DistributionCenter: "Greensboro",
    CitiesTowns: "Sanford, Reidsville, Towns around Greensboro M-Z",
  },
  "274": {
    // Prefix: "274",
    // State: "NC",
    // DistributionCenter: "Greensboro",
    CitiesTowns: "GREENSBORO",
  },
  "275": {
    // Prefix: "275",
    // State: "NC",
    // DistributionCenter: "Raleigh",
    CitiesTowns: "Chapel Hill, Goldsboro",
  },
  "276": {
    // Prefix: "276",
    // State: "NC",
    // DistributionCenter: "Raleigh",
    CitiesTowns: "RALEIGH",
  },
  "277": {
    // Prefix: "277",
    // State: "NC",
    // DistributionCenter: "Raleigh",
    CitiesTowns: "DURHAM",
  },
  "278": {
    // Prefix: "278",
    // State: "NC",
    // DistributionCenter: "Rocky Mount",
    CitiesTowns: "<i>Rocky Mount</i>, Greenville",
  },
  "279": {
    // Prefix: "279",
    // State: "NC",
    // DistributionCenter: "Rocky Mount",
    CitiesTowns: "<i>Elizabeth City</i>, Nags Head",
  },
  "280": {
    // Prefix: "280",
    // State: "NC",
    // DistributionCenter: "Charlotte",
    CitiesTowns: "Gastonia, Concord, Areas around Charlotte A-L",
  },
  "281": {
    // Prefix: "281",
    // State: "NC",
    // DistributionCenter: "Charlotte",
    CitiesTowns: "Monroe, Salisbury, Areas around Charlotte M-Z",
  },
  "282": {
    // Prefix: "282",
    // State: "NC",
    // DistributionCenter: "Charlotte",
    CitiesTowns: "CHARLOTTE",
  },
  "283": {
    // Prefix: "283",
    // State: "NC",
    // DistributionCenter: "Fayetteville",
    CitiesTowns: "<i>Fayetteville</i>, Rockingham",
  },
  "284": {
    // Prefix: "284",
    // State: "NC",
    // DistributionCenter: "Fayetteville",
    CitiesTowns: "<i>Wilmington</i>, Whiteville",
  },
  "285": {
    // Prefix: "285",
    // State: "NC",
    // DistributionCenter: "Kinston",
    CitiesTowns: "<i>Kinston, </i> Jacksonville",
  },
  "286": {
    // Prefix: "286",
    // State: "NC",
    // DistributionCenter: "Hickory",
    CitiesTowns: "<i>Hickory</i>, Boone",
  },
  "287": {
    // Prefix: "287",
    // State: "NC",
    // DistributionCenter: "Asheville",
    CitiesTowns: "Hendersonville, Franklin, Areas around Asheville",
  },
  "288": {
    // Prefix: "288",
    // State: "NC",
    // DistributionCenter: "Asheville",
    CitiesTowns: "ASHEVILLE",
  },
  "289": {
    // Prefix: "289",
    // State: "NC",
    // DistributionCenter: "Asheville",
    CitiesTowns: "Murphy, Hayesville",
  },
  "290": {
    // Prefix: "290",
    // State: "SC",
    // DistributionCenter: "Columbia",
    CitiesTowns: "Camden, Lexington, Areas around Columbia A-L",
  },
  "291": {
    // Prefix: "291",
    // State: "SC",
    // DistributionCenter: "Columbia",
    CitiesTowns: "Orangeburg, Sumter, Areas around Columbia M-Z",
  },
  "292": {
    // Prefix: "292",
    // State: "SC",
    // DistributionCenter: "Columbia",
    CitiesTowns: "COLUMBIA",
  },
  "293": {
    // Prefix: "293",
    // State: "SC",
    // DistributionCenter: "Greenville",
    CitiesTowns: "<i>Spartanburg</i>, Gaffney",
  },
  "294": {
    // Prefix: "294",
    // State: "SC",
    // DistributionCenter: "Charleston",
    CitiesTowns: "<i>Charleston</i>, Georgetown",
  },
  "295": {
    // Prefix: "295",
    // State: "SC",
    // DistributionCenter: "Florence",
    CitiesTowns: "<i>Florence</i>, Myrtle Beach",
  },
  "296": {
    // Prefix: "296",
    // State: "SC",
    // DistributionCenter: "Greenville",
    CitiesTowns: "<i>Greenville</i>, Anderson",
  },
  "297": {
    // Prefix: "297",
    // State: "SC",
    // DistributionCenter: "Charlotte, NC",
    CitiesTowns: "Rock Hill, Lancaster",
  },
  "298": {
    // Prefix: "298",
    // State: "SC",
    // DistributionCenter: "Augusta, GA",
    CitiesTowns: "<i>Aiken</i>, Bamberg",
  },
  "299": {
    // Prefix: "299",
    // State: "SC",
    // DistributionCenter: "Savannah, GA",
    CitiesTowns: "Hilton Head",
  },
  "300": {
    // Prefix: "300",
    // State: "GA",
    // DistributionCenter: "North Metro",
    CitiesTowns: "Marietta, Decatur, North Atlanta Suburbs",
  },
  "301": {
    // Prefix: "301",
    // State: "GA",
    // DistributionCenter: "North Metro",
    CitiesTowns: "Douglasville, Rome, West Atlanta Suburbs",
  },
  "302": {
    // Prefix: "302",
    // State: "GA",
    // DistributionCenter: "Atlanta",
    CitiesTowns: "Newnan, Stockbridge, South Atlanta Suburbs",
  },
  "303": {
    // Prefix: "303",
    // State: "GA",
    // DistributionCenter: "Atlanta",
    CitiesTowns: "ATLANTA",
  },
  "304": {
    // Prefix: "304",
    // State: "GA",
    // DistributionCenter: "Swainsboro",
    CitiesTowns: "<i>Swainsboro</i>, Statesboro",
  },
  "305": {
    // Prefix: "305",
    // State: "GA",
    // DistributionCenter: "Athens",
    CitiesTowns: "<i>Gainesville</i>, Blairsville",
  },
  "306": {
    // Prefix: "306",
    // State: "GA",
    // DistributionCenter: "Athens",
    CitiesTowns: "<i>Athens</i>, Elberton",
  },
  "307": {
    // Prefix: "307",
    // State: "GA",
    // DistributionCenter: "Chattanooga, TN",
    CitiesTowns: "<i>Calhoun</i>, Dalton",
  },
  "308": {
    // Prefix: "308",
    // State: "GA",
    // DistributionCenter: "Augusta",
    CitiesTowns: "Thomson, Waynesboro",
  },
  "309": {
    // Prefix: "309",
    // State: "GA",
    // DistributionCenter: "Augusta",
    CitiesTowns: "AUGUSTA",
  },
  "310": {
    // Prefix: "310",
    // State: "GA",
    // DistributionCenter: "Macon",
    CitiesTowns: "Dublin, Warner Robbins, areas around Macon",
  },
  "311": {
    // Prefix: "311",
    // State: "GA",
    // DistributionCenter: "Atlanta",
    CitiesTowns: "ATLANTA",
  },
  "312": {
    // Prefix: "312",
    // State: "GA",
    // DistributionCenter: "Macon",
    CitiesTowns: "MACON",
  },
  "313": {
    // Prefix: "313",
    // State: "GA",
    // DistributionCenter: "Savannah",
    CitiesTowns: "Hinesville, Pooler, areas around Savannah",
  },
  "314": {
    // Prefix: "314",
    // State: "GA",
    // DistributionCenter: "Savannah",
    CitiesTowns: "SAVANNAH",
  },
  "315": {
    // Prefix: "315",
    // State: "GA",
    // DistributionCenter: "Waycross",
    CitiesTowns: "<i>Waycross</i>, Brunswick",
  },
  "316": {
    // Prefix: "316",
    // State: "GA",
    // DistributionCenter: "Valdosta",
    CitiesTowns: "<i>Valdosta</i>, Homerville",
  },
  "317": {
    // Prefix: "317",
    // State: "GA",
    // DistributionCenter: "Albany",
    CitiesTowns: "<i>Albany</i>, Thomasville",
  },
  "318": {
    // Prefix: "318",
    // State: "GA",
    // DistributionCenter: "Columbus",
    CitiesTowns: "Warm Springs, Cusseta, areas around Columbus",
  },
  "319": {
    // Prefix: "319",
    // State: "GA",
    // DistributionCenter: "Columbus",
    CitiesTowns: "COLUMBUS",
  },
  "320": {
    // Prefix: "320",
    // State: "FL",
    // DistributionCenter: "Jacksonville",
    CitiesTowns: "St. Augustine, Lake City, areas around Jacksonville",
  },
  "321": {
    // Prefix: "321",
    // State: "FL",
    // DistributionCenter: "Daytona Beach",
    CitiesTowns: "Daytona Beach, Palm Coast",
  },
  "322": {
    // Prefix: "322",
    // State: "FL",
    // DistributionCenter: "Jacksonville",
    CitiesTowns: "JACKSONVILLE",
  },
  "323": {
    // Prefix: "323",
    // State: "FL",
    // DistributionCenter: "Tallahassee",
    CitiesTowns: "<i>Tallahassee</i>, Apalachicola",
  },
  "324": {
    // Prefix: "324",
    // State: "FL",
    // DistributionCenter: "Panama City",
    CitiesTowns: "<i>Panama City</i>, Marianna",
  },
  "325": {
    // Prefix: "325",
    // State: "FL",
    // DistributionCenter: "Pensacola",
    CitiesTowns: "<i>Pensacola</i>, Fort Walton Beach",
  },
  "326": {
    // Prefix: "326",
    // State: "FL",
    // DistributionCenter: "Gainesville",
    CitiesTowns: "<i>Gainesville</i>, Chiefland",
  },
  "327": {
    // Prefix: "327",
    // State: "FL",
    // DistributionCenter: "Mid-Florida",
    CitiesTowns: "Sanford, Titusville",
  },
  "328": {
    // Prefix: "328",
    // State: "FL",
    // DistributionCenter: "Orlando",
    CitiesTowns: "ORLANDO",
  },
  "329": {
    // Prefix: "329",
    // State: "FL",
    // DistributionCenter: "Orlando",
    CitiesTowns: "<i>Melbourne</i>, Vero Beach",
  },
  "330": {
    // Prefix: "330",
    // State: "FL",
    // DistributionCenter: "South Florida",
    CitiesTowns: "Key West, Hollywood, Areas around Miami and Ft. Lauderdale",
  },
  "331": {
    // Prefix: "331",
    // State: "FL",
    // DistributionCenter: "Miami",
    CitiesTowns: "MIAMI",
  },
  "332": {
    // Prefix: "332",
    // State: "FL",
    // DistributionCenter: "Miami",
    CitiesTowns: "MIAMI",
  },
  "333": {
    // Prefix: "333",
    // State: "FL",
    // DistributionCenter: "Ft. Lauderdale",
    CitiesTowns: "FORT LAUDERDALE",
  },
  "334": {
    // Prefix: "334",
    // State: "FL",
    // DistributionCenter: "West Palm Beach",
    CitiesTowns: "<i>West Palm Beach</i>, Boca Raton",
  },
  "335": {
    // Prefix: "335",
    // State: "FL",
    // DistributionCenter: "Tampa",
    CitiesTowns: "Zephyrhills, Plant City, areas around Tampa",
  },
  "336": {
    // Prefix: "336",
    // State: "FL",
    // DistributionCenter: "Tampa",
    CitiesTowns: "TAMPA",
  },
  "337": {
    // Prefix: "337",
    // State: "FL",
    // DistributionCenter: "St. Petersburg",
    CitiesTowns: "<i>St. Petersburg</i>, Clearwater",
  },
  "338": {
    // Prefix: "338",
    // State: "FL",
    // DistributionCenter: "Lakeland",
    CitiesTowns: "<i>Lakeland</i>, Sebring",
  },
  "339": {
    // Prefix: "339",
    // State: "FL",
    // DistributionCenter: "Fort Myers",
    CitiesTowns: "<i>Fort Myers</i>, Punta Gorda",
  },
  "340": {
    // Prefix: "340",
    // State: "AA",
    // DistributionCenter: "Miami, FL",
    CitiesTowns: "Bases in Latin America",
  },
  "341": {
    // Prefix: "341",
    // State: "FL",
    // DistributionCenter: "Fort Myers",
    CitiesTowns: "<i>Naples</i>, Everglades City",
  },
  "342": {
    // Prefix: "342",
    // State: "FL",
    // DistributionCenter: "Manasota",
    CitiesTowns: "Sarasota, <i>Bradenton</i>",
  },
  "343": {
    // Prefix: "343",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "344": {
    // Prefix: "344",
    // State: "FL",
    // DistributionCenter: "Gainesville",
    CitiesTowns: "Ocala, Inverness",
  },
  "345": {
    // Prefix: "345",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "346": {
    // Prefix: "346",
    // State: "FL",
    // DistributionCenter: "Tampa",
    CitiesTowns: "<i>Brooksville</i>, New Port Richey",
  },
  "347": {
    // Prefix: "347",
    // State: "FL",
    // DistributionCenter: "Orlando",
    CitiesTowns: "Kissimee, Leesburg",
  },
  "348": {
    // Prefix: "348",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "349": {
    // Prefix: "349",
    // State: "FL",
    // DistributionCenter: "West Palm Beach",
    CitiesTowns: "<i>Fort Pierce</i>, Stuart",
  },
  "350": {
    // Prefix: "350",
    // State: "AL",
    // DistributionCenter: "Birmingham",
    CitiesTowns: "Bessemer, Cullman, areas around Birmingham A-L",
  },
  "351": {
    // Prefix: "351",
    // State: "AL",
    // DistributionCenter: "Birmingham",
    CitiesTowns: "Oneonta, Sylacauga, areas around Birmingham M-Z",
  },
  "352": {
    // Prefix: "352",
    // State: "AL",
    // DistributionCenter: "Birmingham",
    CitiesTowns: "BIRMINGHAM",
  },
  "353": {
    // Prefix: "353",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "354": {
    // Prefix: "354",
    // State: "AL",
    // DistributionCenter: "Tuscaloosa",
    CitiesTowns: "<i>Tuscaloosa</i>, Eutaw",
  },
  "355": {
    // Prefix: "355",
    // State: "AL",
    // DistributionCenter: "Birmingham",
    CitiesTowns: "<i>Jasper</i>, Hamilton",
  },
  "356": {
    // Prefix: "356",
    // State: "AL",
    // DistributionCenter: "Huntsville",
    CitiesTowns: "<i>Decatur</i>, Florence",
  },
  "357": {
    // Prefix: "357",
    // State: "AL",
    // DistributionCenter: "Huntsville",
    CitiesTowns: "Scottsboro, Madison, areas around Huntsville",
  },
  "358": {
    // Prefix: "358",
    // State: "AL",
    // DistributionCenter: "Huntsville",
    CitiesTowns: "HUNTSVILLE",
  },
  "359": {
    // Prefix: "359",
    // State: "AL",
    // DistributionCenter: "Birmingham",
    CitiesTowns: "<i>Gadsden</i>, Fort Payne",
  },
  "360": {
    // Prefix: "360",
    // State: "AL",
    // DistributionCenter: "Montgomery",
    CitiesTowns: "Prattville, Eufala, areas around Montgomery",
  },
  "361": {
    // Prefix: "361",
    // State: "AL",
    // DistributionCenter: "Montgomery",
    CitiesTowns: "MONTGOMERY",
  },
  "362": {
    // Prefix: "362",
    // State: "AL",
    // DistributionCenter: "Anniston",
    CitiesTowns: "<i>Anniston</i>, Roanoke",
  },
  "363": {
    // Prefix: "363",
    // State: "AL",
    // DistributionCenter: "Dothan",
    CitiesTowns: "<i>Dothan</i>, Enterprise",
  },
  "364": {
    // Prefix: "364",
    // State: "AL",
    // DistributionCenter: "Montgomery",
    CitiesTowns: "<i>Evergreen</i>, Opp",
  },
  "365": {
    // Prefix: "365",
    // State: "AL",
    // DistributionCenter: "Mobile",
    CitiesTowns: "Gulf Shores, Jackson, areas around Mobile",
  },
  "366": {
    // Prefix: "366",
    // State: "AL",
    // DistributionCenter: "Mobile",
    CitiesTowns: "MOBILE",
  },
  "367": {
    // Prefix: "367",
    // State: "AL",
    // DistributionCenter: "Montgomery",
    CitiesTowns: "<i>Selma</i>, Thomasville",
  },
  "368": {
    // Prefix: "368",
    // State: "AL",
    // DistributionCenter: "Montgomery",
    CitiesTowns: "Auburn, Phenix City, <i>Opelika</i>",
  },
  "369": {
    // Prefix: "369",
    // State: "AL",
    // DistributionCenter: "Meridian, MS",
    CitiesTowns: "York, Butler",
  },
  "370": {
    // Prefix: "370",
    // State: "TN",
    // DistributionCenter: "Nashville",
    CitiesTowns: "Clarksville, Lebanon, areas around Nashville A-L",
  },
  "371": {
    // Prefix: "371",
    // State: "TN",
    // DistributionCenter: "Nashville",
    CitiesTowns: "Murfreesvoro, White House, areas around Nashville M-Z",
  },
  "372": {
    // Prefix: "372",
    // State: "TN",
    // DistributionCenter: "Nashville",
    CitiesTowns: "NASHVILLE",
  },
  "373": {
    // Prefix: "373",
    // State: "TN",
    // DistributionCenter: "Chattanooga",
    CitiesTowns: "Dayton, Fayetteville, areas around Chattanooga",
  },
  "374": {
    // Prefix: "374",
    // State: "TN",
    // DistributionCenter: "Chattanooga",
    CitiesTowns: "CHATTANOOGA",
  },
  "375": {
    // Prefix: "375",
    // State: "TN",
    // DistributionCenter: "Memphis",
    CitiesTowns: "IRS",
  },
  "376": {
    // Prefix: "376",
    // State: "TN",
    // DistributionCenter: "Johnson City",
    CitiesTowns: "<i>Johnson City</i>, Bristol",
  },
  "377": {
    // Prefix: "377",
    // State: "TN",
    // DistributionCenter: "Knoxville",
    CitiesTowns: "Gatlinburg, La Follette, areas around Knoxville A-L",
  },
  "378": {
    // Prefix: "378",
    // State: "TN",
    // DistributionCenter: "Knoxville",
    CitiesTowns: "Oak Ridge, Morristown, areas around Knoxville M-Z",
  },
  "379": {
    // Prefix: "379",
    // State: "TN",
    // DistributionCenter: "Knoxville",
    CitiesTowns: "KNOXVILLE",
  },
  "380": {
    // Prefix: "380",
    // State: "TN",
    // DistributionCenter: "Memphis",
    CitiesTowns: "Covington, Bolivar, areas around Memphis",
  },
  "381": {
    // Prefix: "381",
    // State: "TN",
    // DistributionCenter: "Memphis",
    CitiesTowns: "MEMPHIS",
  },
  "382": {
    // Prefix: "382",
    // State: "TN",
    // DistributionCenter: "McKenzie",
    CitiesTowns: "<i>McKenzie</i>, Union City",
  },
  "383": {
    // Prefix: "383",
    // State: "TN",
    // DistributionCenter: "Jackson",
    CitiesTowns: "<i>Jackson</i>, Savannah",
  },
  "384": {
    // Prefix: "384",
    // State: "TN",
    // DistributionCenter: "Columbia",
    CitiesTowns: "<i>Columbia</i>, Pulaski",
  },
  "385": {
    // Prefix: "385",
    // State: "TN",
    // DistributionCenter: "Cookeville",
    CitiesTowns: "<i>Cookeville</i>, Crossville",
  },
  "386": {
    // Prefix: "386",
    // State: "MS",
    // DistributionCenter: "Memphis, TN",
    CitiesTowns: "Oxford, Clarksdale",
  },
  "387": {
    // Prefix: "387",
    // State: "MS",
    // DistributionCenter: "Greenville",
    CitiesTowns: "<i>Greenville</i>, Indianola",
  },
  "388": {
    // Prefix: "388",
    // State: "MS",
    // DistributionCenter: "Tupelo",
    CitiesTowns: "<i>Tupelo</i>, Corinth",
  },
  "389": {
    // Prefix: "389",
    // State: "MS",
    // DistributionCenter: "Grenada",
    CitiesTowns: "<i>Grenada</i>, Greenwood",
  },
  "390": {
    // Prefix: "390",
    // State: "MS",
    // DistributionCenter: "Jackson",
    CitiesTowns: "Canton, Crystal Springs, areas around Jackson A-L",
  },
  "391": {
    // Prefix: "391",
    // State: "MS",
    // DistributionCenter: "Jackson",
    CitiesTowns: "Vicksburg, Natchez, areas around Jackson M-Z",
  },
  "392": {
    // Prefix: "392",
    // State: "MS",
    // DistributionCenter: "Jackson",
    CitiesTowns: "JACKSON",
  },
  "393": {
    // Prefix: "393",
    // State: "MS",
    // DistributionCenter: "Meridian",
    CitiesTowns: "<i>Meridian</i>, Louisville",
  },
  "394": {
    // Prefix: "394",
    // State: "MS",
    // DistributionCenter: "Hattiesburg",
    CitiesTowns: "<i>Hattiesburg</i>, Laurel",
  },
  "395": {
    // Prefix: "395",
    // State: "MS",
    // DistributionCenter: "Gulfport",
    CitiesTowns: "<i>Gulfport</i>, Biloxi",
  },
  "396": {
    // Prefix: "396",
    // State: "MS",
    // DistributionCenter: "McComb",
    CitiesTowns: "<i>McComb</i>, Brookhaven",
  },
  "397": {
    // Prefix: "397",
    // State: "MS",
    // DistributionCenter: "Columbus",
    CitiesTowns: "<i>Columbus</i>, Starkville",
  },
  "398": {
    // Prefix: "398",
    // State: "GA",
    // DistributionCenter: "Albany",
    CitiesTowns: "Bainbridge, Cairo",
  },
  "399": {
    // Prefix: "399",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "400": {
    // Prefix: "400",
    // State: "KY",
    // DistributionCenter: "Louisville",
    CitiesTowns: "Shelbyville, La Grange, areas east of Louisville",
  },
  "401": {
    // Prefix: "401",
    // State: "KY",
    // DistributionCenter: "Louisville",
    CitiesTowns: "Fort Knox, Shepherdsville, areas east of Louisville",
  },
  "402": {
    // Prefix: "402",
    // State: "KY",
    // DistributionCenter: "Louisville",
    CitiesTowns: "LOUISVILLE",
  },
  "403": {
    // Prefix: "403",
    // State: "KY",
    // DistributionCenter: "Lexington",
    CitiesTowns: "Morehead, Nicholasville, areas around Lexington",
  },
  "404": {
    // Prefix: "404",
    // State: "KY",
    // DistributionCenter: "Lexington",
    CitiesTowns: "Richmond, Danville, areas south of Lexington",
  },
  "405": {
    // Prefix: "405",
    // State: "KY",
    // DistributionCenter: "Lexington",
    CitiesTowns: "LEXINGTON",
  },
  "406": {
    // Prefix: "406",
    // State: "KY",
    // DistributionCenter: "Lexington",
    CitiesTowns: "FRANKFORT",
  },
  "407": {
    // Prefix: "407",
    // State: "KY",
    // DistributionCenter: "London",
    CitiesTowns: "London, <i>Corbin</i>",
  },
  "408": {
    // Prefix: "408",
    // State: "KY",
    // DistributionCenter: "London",
    CitiesTowns: "Harlan, Lynch",
  },
  "409": {
    // Prefix: "409",
    // State: "KY",
    // DistributionCenter: "London",
    CitiesTowns: "Middlesboro, Manchester",
  },
  "410": {
    // Prefix: "410",
    // State: "KY",
    // DistributionCenter: "Cincinnati, OH",
    CitiesTowns: "Covington, Maysville",
  },
  "411": {
    // Prefix: "411",
    // State: "KY",
    // DistributionCenter: "Ashland",
    CitiesTowns: "<i>Ashland</i>, Vanceburg",
  },
  "412": {
    // Prefix: "412",
    // State: "KY",
    // DistributionCenter: "Ashland",
    CitiesTowns: "Lousia, Paintsville",
  },
  "413": {
    // Prefix: "413",
    // State: "KY",
    // DistributionCenter: "Campton",
    CitiesTowns: "<i>Campton</i>, Jackson",
  },
  "414": {
    // Prefix: "414",
    // State: "KY",
    // DistributionCenter: "Campton",
    CitiesTowns: "Saylersville, West Liberty",
  },
  "415": {
    // Prefix: "415",
    // State: "KY",
    // DistributionCenter: "Pikeville",
    CitiesTowns: "<i>Pikeville</i>, Jenkins",
  },
  "416": {
    // Prefix: "416",
    // State: "KY",
    // DistributionCenter: "Pikeville",
    CitiesTowns: "Prestonsburg, Wayland",
  },
  "417": {
    // Prefix: "417",
    // State: "KY",
    // DistributionCenter: "Hazard",
    CitiesTowns: "<i>Hazard</i>, Hyden",
  },
  "418": {
    // Prefix: "418",
    // State: "KY",
    // DistributionCenter: "Hazard",
    CitiesTowns: "Whitesburg, Gamer",
  },
  "419": {
    // Prefix: "419",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "420": {
    // Prefix: "420",
    // State: "KY",
    // DistributionCenter: "Paducah",
    CitiesTowns: "<i>Paducah</i>, Murray",
  },
  "421": {
    // Prefix: "421",
    // State: "KY",
    // DistributionCenter: "Bowling Green",
    CitiesTowns: "<i>Bowling Green</i>, Glasgow",
  },
  "422": {
    // Prefix: "422",
    // State: "KY",
    // DistributionCenter: "Bowling Green",
    CitiesTowns: "Hopkinsville, Russellville",
  },
  "423": {
    // Prefix: "423",
    // State: "KY",
    // DistributionCenter: "Owensboro",
    CitiesTowns: "<i>Owensboro</i>, Central City",
  },
  "424": {
    // Prefix: "424",
    // State: "KY",
    // DistributionCenter: "Evansville, IN",
    CitiesTowns: "Henderson, Madisonville",
  },
  "425": {
    // Prefix: "425",
    // State: "KY",
    // DistributionCenter: "Somerset",
    CitiesTowns: "<i>Somerset</i>, Liberty",
  },
  "426": {
    // Prefix: "426",
    // State: "KY",
    // DistributionCenter: "Somerset",
    CitiesTowns: "Russell Springs, Monticello",
  },
  "427": {
    // Prefix: "427",
    // State: "KY",
    // DistributionCenter: "Elizabethtown",
    CitiesTowns: "<i>Elizabethtown</i>, Campbellsville",
  },
  "428": {
    // Prefix: "428",
    // State: "NOT USED",
    // DistributionCenter: "  ",
    CitiesTowns: "  ",
  },
  "429": {
    // Prefix: "429",
    // State: "NOT USED",
    // DistributionCenter: "  ",
    CitiesTowns: "  ",
  },
  "430": {
    // Prefix: "430",
    // State: "OH",
    // DistributionCenter: "Columbus",
    CitiesTowns: "Newark, Dublin, areas north of Columbus",
  },
  "431": {
    // Prefix: "431",
    // State: "OH",
    // DistributionCenter: "Columbus",
    CitiesTowns: "Washington Court House, Lancaster, areas south of Columbus",
  },
  "432": {
    // Prefix: "432",
    // State: "OH",
    // DistributionCenter: "Columbus",
    CitiesTowns: "COLUMBUS",
  },
  "433": {
    // Prefix: "433",
    // State: "OH",
    // DistributionCenter: "Columbus",
    CitiesTowns: "<i>Marion</i>, Upper Sandusky",
  },
  "434": {
    // Prefix: "434",
    // State: "OH",
    // DistributionCenter: "Toledo",
    CitiesTowns: "Bowling Green, Port Clinton, areas east of Toledo",
  },
  "435": {
    // Prefix: "435",
    // State: "OH",
    // DistributionCenter: "Toledo",
    CitiesTowns: "Bryan, Perrysburg, areas west of Toledo",
  },
  "436": {
    // Prefix: "436",
    // State: "OH",
    // DistributionCenter: "Toledo",
    CitiesTowns: "TOLEDO",
  },
  "437": {
    // Prefix: "437",
    // State: "OH",
    // DistributionCenter: "Zanesville",
    CitiesTowns: "<i>Zanesville</i>, Cambridge",
  },
  "438": {
    // Prefix: "438",
    // State: "OH",
    // DistributionCenter: "Zanesville",
    CitiesTowns: "Coshocton, Blissfiled",
  },
  "439": {
    // Prefix: "439",
    // State: "OH",
    // DistributionCenter: "Steubenville",
    CitiesTowns: "Steubenville, St. Clairsville",
  },
  "440": {
    // Prefix: "440",
    // State: "OH",
    // DistributionCenter: "Cleveland",
    CitiesTowns: "Elyria, Asthtabula, areas around Cleveland",
  },
  "441": {
    // Prefix: "441",
    // State: "OH",
    // DistributionCenter: "Cleveland",
    CitiesTowns: "CLEVELAND",
  },
  "442": {
    // Prefix: "442",
    // State: "OH",
    // DistributionCenter: "Akron",
    CitiesTowns: "Kent, Medina, areas around Akron",
  },
  "443": {
    // Prefix: "443",
    // State: "OH",
    // DistributionCenter: "Akron",
    CitiesTowns: "AKRON",
  },
  "444": {
    // Prefix: "444",
    // State: "OH",
    // DistributionCenter: "Youngstown",
    CitiesTowns: "Warren, Boardman",
  },
  "445": {
    // Prefix: "445",
    // State: "OH",
    // DistributionCenter: "Youngstown",
    CitiesTowns: "YOUNGSTOWN",
  },
  "446": {
    // Prefix: "446",
    // State: "OH",
    // DistributionCenter: "Canton",
    CitiesTowns: "Alliance, New Philadelphia",
  },
  "447": {
    // Prefix: "447",
    // State: "OH",
    // DistributionCenter: "Canton",
    CitiesTowns: "CANTON",
  },
  "448": {
    // Prefix: "448",
    // State: "OH",
    // DistributionCenter: "Mansfield",
    CitiesTowns: "Sandusky, Ashland",
  },
  "449": {
    // Prefix: "449",
    // State: "OH",
    // DistributionCenter: "Mansfield",
    CitiesTowns: "MANSFIELD",
  },
  "450": {
    // Prefix: "450",
    // State: "OH",
    // DistributionCenter: "Cincinnati",
    CitiesTowns: "Oxford, Lebanon, areas around Cincinnati",
  },
  "451": {
    // Prefix: "451",
    // State: "OH",
    // DistributionCenter: "Cincinnati",
    CitiesTowns: "Wilmington, Hillsboro, areas east of Cincinnati",
  },
  "452": {
    // Prefix: "452",
    // State: "OH",
    // DistributionCenter: "Cincinnati",
    CitiesTowns: "CINCINNATI",
  },
  "453": {
    // Prefix: "453",
    // State: "OH",
    // DistributionCenter: "Dayton",
    CitiesTowns: "Xenia, Sidney, areas around Dayton",
  },
  "454": {
    // Prefix: "454",
    // State: "OH",
    // DistributionCenter: "Dayton",
    CitiesTowns: "DAYTON",
  },
  "455": {
    // Prefix: "455",
    // State: "OH",
    // DistributionCenter: "Dayton",
    CitiesTowns: "SPRINGFIELD",
  },
  "456": {
    // Prefix: "456",
    // State: "OH",
    // DistributionCenter: "Chillicothe",
    CitiesTowns: "<i>Chillicothe</i>, Portsmouth",
  },
  "457": {
    // Prefix: "457",
    // State: "OH",
    // DistributionCenter: "Athens",
    CitiesTowns: "<i>Athens</i>, Marietta",
  },
  "458": {
    // Prefix: "458",
    // State: "OH",
    // DistributionCenter: "Lima",
    CitiesTowns: "<i>Lima</i>, Findlay",
  },
  "459": {
    // Prefix: "459",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "460": {
    // Prefix: "460",
    // State: "IN",
    // DistributionCenter: "Indianapolis",
    CitiesTowns: "Anderson, Noblesville, areas north of Indianapolis",
  },
  "461": {
    // Prefix: "461",
    // State: "IN",
    // DistributionCenter: "Indianapolis",
    CitiesTowns: "Greenwood, Shelbyville, areas south of Indianapolis",
  },
  "462": {
    // Prefix: "462",
    // State: "IN",
    // DistributionCenter: "Indianapolis",
    CitiesTowns: "INDIANAPOLIS",
  },
  "463": {
    // Prefix: "463",
    // State: "IN",
    // DistributionCenter: "Gary",
    CitiesTowns: "Hammond, La Porte, areas around Gary",
  },
  "464": {
    // Prefix: "464",
    // State: "IN",
    // DistributionCenter: "Gary",
    CitiesTowns: "GARY",
  },
  "465": {
    // Prefix: "465",
    // State: "IN",
    // DistributionCenter: "South Bend",
    CitiesTowns: "Elkhart, Plymouth, areas around South Bend",
  },
  "466": {
    // Prefix: "466",
    // State: "IN",
    // DistributionCenter: "South Bend",
    CitiesTowns: "SOUTH BEND",
  },
  "467": {
    // Prefix: "467",
    // State: "IN",
    // DistributionCenter: "Fort Wayne",
    CitiesTowns: "Angola, Huntington, areas around Fort Wayne",
  },
  "468": {
    // Prefix: "468",
    // State: "IN",
    // DistributionCenter: "Fort Wayne",
    CitiesTowns: "FORT WAYNE",
  },
  "469": {
    // Prefix: "469",
    // State: "IN",
    // DistributionCenter: "Kokomo",
    CitiesTowns: "<i>Kokomo</i>, Marion",
  },
  "470": {
    // Prefix: "470",
    // State: "IN",
    // DistributionCenter: "Cincinnati, OH",
    CitiesTowns: "Batesville, Greensburg",
  },
  "471": {
    // Prefix: "471",
    // State: "IN",
    // DistributionCenter: "Louisville, KY",
    CitiesTowns: "New Albany, Corydon",
  },
  "472": {
    // Prefix: "472",
    // State: "IN",
    // DistributionCenter: "Columbus",
    CitiesTowns: "<i>Columbus</i>, Madison",
  },
  "473": {
    // Prefix: "473",
    // State: "IN",
    // DistributionCenter: "Muncie",
    CitiesTowns: "<i>Muncie</i>, Richmond",
  },
  "474": {
    // Prefix: "474",
    // State: "IN",
    // DistributionCenter: "Bloomington",
    CitiesTowns: "<i>Bloomington</i>, Paoli",
  },
  "475": {
    // Prefix: "475",
    // State: "IN",
    // DistributionCenter: "Washington",
    CitiesTowns: "<i>Washington</i>, Tell City",
  },
  "476": {
    // Prefix: "476",
    // State: "IN",
    // DistributionCenter: "Evansville",
    CitiesTowns: "Mount Vernon, Boonville, areas around Evansville",
  },
  "477": {
    // Prefix: "477",
    // State: "IN",
    // DistributionCenter: "Evansville",
    CitiesTowns: "EVANSVILLE",
  },
  "478": {
    // Prefix: "478",
    // State: "IN",
    // DistributionCenter: "Terre Haute",
    CitiesTowns: "<i>Terre Haute</i>, Sullivan",
  },
  "479": {
    // Prefix: "479",
    // State: "IN",
    // DistributionCenter: "Lafayette",
    CitiesTowns: "<i>Lafayette</i>, Crawfordsville",
  },
  "480": {
    // Prefix: "480",
    // State: "MI",
    // DistributionCenter: "Royal Oak",
    CitiesTowns: "Warren, Port Huron, Northeast Detroit Suburbs",
  },
  "481": {
    // Prefix: "481",
    // State: "MI",
    // DistributionCenter: "Detroit",
    CitiesTowns: "Ann Arbor, Dearborn, Southwest Detroit suburbs",
  },
  "482": {
    // Prefix: "482",
    // State: "MI",
    // DistributionCenter: "Detroit",
    CitiesTowns: "DETROIT",
  },
  "483": {
    // Prefix: "483",
    // State: "MI",
    // DistributionCenter: "Royal Oak",
    CitiesTowns: "Pontaic, Auburn Hills, Northwest Detroit Suburbs",
  },
  "484": {
    // Prefix: "484",
    // State: "MI",
    // DistributionCenter: "Flint",
    CitiesTowns: "Birch Run, Lapeer, areas around Flint",
  },
  "485": {
    // Prefix: "485",
    // State: "MI",
    // DistributionCenter: "Flint",
    CitiesTowns: "FLINT",
  },
  "486": {
    // Prefix: "486",
    // State: "MI",
    // DistributionCenter: "Saginaw",
    CitiesTowns: "<i>Saginaw</i>, Midland",
  },
  "487": {
    // Prefix: "487",
    // State: "MI",
    // DistributionCenter: "Saginaw",
    CitiesTowns: "Bay City, Tawas City",
  },
  "488": {
    // Prefix: "488",
    // State: "MI",
    // DistributionCenter: "Lansing",
    CitiesTowns: "Mount Pleasant, Howell, areas around Lansing",
  },
  "489": {
    // Prefix: "489",
    // State: "MI",
    // DistributionCenter: "Lansing",
    CitiesTowns: "LANSING",
  },
  "490": {
    // Prefix: "490",
    // State: "MI",
    // DistributionCenter: "Kalamazoo",
    CitiesTowns: "<i>Kalamazoo</i>, Battle Creek",
  },
  "491": {
    // Prefix: "491",
    // State: "MI",
    // DistributionCenter: "Kalamazoo",
    CitiesTowns: "New Buffalo, Niles",
  },
  "492": {
    // Prefix: "492",
    // State: "MI",
    // DistributionCenter: "Jackson",
    CitiesTowns: "Jackson, Adrian",
  },
  "493": {
    // Prefix: "493",
    // State: "MI",
    // DistributionCenter: "Grand Rapids",
    CitiesTowns: "Big Rapids, Reed City",
  },
  "494": {
    // Prefix: "494",
    // State: "MI",
    // DistributionCenter: "Grand Rapids",
    CitiesTowns: "Muskegon, Ludington, areas around Grand Rapids",
  },
  "495": {
    // Prefix: "495",
    // State: "MI",
    // DistributionCenter: "Grand Rapids",
    CitiesTowns: "GRAND RAPIDS",
  },
  "496": {
    // Prefix: "496",
    // State: "MI",
    // DistributionCenter: "Traverse City",
    CitiesTowns: "Traverse City, <i>Cadillac</i>",
  },
  "497": {
    // Prefix: "497",
    // State: "MI",
    // DistributionCenter: "Gaylord",
    CitiesTowns: "Gaylord, Sault Ste. Marie, <i>Mackinaw City</i>",
  },
  "498": {
    // Prefix: "498",
    // State: "MI",
    // DistributionCenter: "Iron Mountain",
    CitiesTowns: "<i>Iron Mountain</i>, Marquette",
  },
  "499": {
    // Prefix: "499",
    // State: "MI",
    // DistributionCenter: "Iron Mountain",
    CitiesTowns: "Houghton, Ironwood",
  },
  "500": {
    // Prefix: "500",
    // State: "IA",
    // DistributionCenter: "Des Moines",
    CitiesTowns: "Ames, Atlantic, areas around Des Moines A-F",
  },
  "501": {
    // Prefix: "501",
    // State: "IA",
    // DistributionCenter: "Des Moines",
    CitiesTowns: "Grinnell, Marshalltown, areas around Des Moines G-M",
  },
  "502": {
    // Prefix: "502",
    // State: "IA",
    // DistributionCenter: "Des Moines",
    CitiesTowns: "Newton, Osceola, areas around Des Moines N-Z",
  },
  "503": {
    // Prefix: "503",
    // State: "IA",
    // DistributionCenter: "Des Moines",
    CitiesTowns: "DES MOINES",
  },
  "504": {
    // Prefix: "504",
    // State: "IA",
    // DistributionCenter: "Mason City",
    CitiesTowns: "<i>Mason City</i>, Clear Lake",
  },
  "505": {
    // Prefix: "505",
    // State: "IA",
    // DistributionCenter: "Fort Dodge",
    CitiesTowns: "<i>Fort Dodge</i>, Algona",
  },
  "506": {
    // Prefix: "506",
    // State: "IA",
    // DistributionCenter: "Waterloo",
    CitiesTowns: "Cedar Falls, Charles City, areas around Waterloo",
  },
  "507": {
    // Prefix: "507",
    // State: "IA",
    // DistributionCenter: "Waterloo",
    CitiesTowns: "WATERLOO",
  },
  "508": {
    // Prefix: "508",
    // State: "IA",
    // DistributionCenter: "Creston",
    CitiesTowns: "<i>Creston</i>, Bedford",
  },
  "509": {
    // Prefix: "509",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "510": {
    // Prefix: "510",
    // State: "IA",
    // DistributionCenter: "Sioux City",
    CitiesTowns: "Cherokee, Orange City, areas around Sioux City",
  },
  "511": {
    // Prefix: "511",
    // State: "IA",
    // DistributionCenter: "Sioux City",
    CitiesTowns: "SIOUX CITY",
  },
  "512": {
    // Prefix: "512",
    // State: "IA",
    // DistributionCenter: "Sioux City",
    CitiesTowns: "<i>Sheldon</i>, Sioux Center",
  },
  "513": {
    // Prefix: "513",
    // State: "IA",
    // DistributionCenter: "Sioux City",
    CitiesTowns: "<i>Spencer</i>, Estherville",
  },
  "514": {
    // Prefix: "514",
    // State: "IA",
    // DistributionCenter: "Carroll",
    CitiesTowns: "<i>Carroll</i>, Denison",
  },
  "515": {
    // Prefix: "515",
    // State: "IA",
    // DistributionCenter: "Omaha, NE",
    CitiesTowns: "<i>Council Bluffs</i>, Red Oak",
  },
  "516": {
    // Prefix: "516",
    // State: "IA",
    // DistributionCenter: "Omaha, NE",
    CitiesTowns: "<i>Shenandoah</i>, Clarinda",
  },
  "517": {
    // Prefix: "517",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "518": {
    // Prefix: "518",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "519": {
    // Prefix: "519",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "520": {
    // Prefix: "520",
    // State: "IA",
    // DistributionCenter: "Dubuque",
    CitiesTowns: "<i>Dubuque</i>, Maquoketa",
  },
  "521": {
    // Prefix: "521",
    // State: "IA",
    // DistributionCenter: "Decorah",
    CitiesTowns: "<i>Decorah</i>, Monona",
  },
  "522": {
    // Prefix: "522",
    // State: "IA",
    // DistributionCenter: "Cedar Rapids",
    CitiesTowns: "Iowa City, Amanosa, areas around Cedar Rapids A-L",
  },
  "523": {
    // Prefix: "523",
    // State: "IA",
    // DistributionCenter: "Cedar Rapids",
    CitiesTowns: "Marengo, Washington, areas around Cedar Rapids",
  },
  "524": {
    // Prefix: "524",
    // State: "IA",
    // DistributionCenter: "Cedar Rapids",
    CitiesTowns: "CEDAR RAPIDS",
  },
  "525": {
    // Prefix: "525",
    // State: "IA",
    // DistributionCenter: "Ottumwa",
    CitiesTowns: "<i>Ottumwa</i>, Oskaloosa",
  },
  "526": {
    // Prefix: "526",
    // State: "IA",
    // DistributionCenter: "Burlington",
    CitiesTowns: "<i>Burlington</i>, Keokuk",
  },
  "527": {
    // Prefix: "527",
    // State: "IA",
    // DistributionCenter: "Rock Island, IL",
    CitiesTowns: "Bettendorf, Clinton, areas around Davenport",
  },
  "528": {
    // Prefix: "528",
    // State: "IA",
    // DistributionCenter: "Rock Island, IL",
    CitiesTowns: "DAVENPORT",
  },
  "529": {
    // Prefix: "529",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "530": {
    // Prefix: "530",
    // State: "WI",
    // DistributionCenter: "Milwaukee",
    CitiesTowns: "Sheboygan, Menomonee Falls, areas north of Milwaukee",
  },
  "531": {
    // Prefix: "531",
    // State: "WI",
    // DistributionCenter: "Milwaukee",
    CitiesTowns: "Kenosha, Waukesha, areas south of Milwaukee",
  },
  "532": {
    // Prefix: "532",
    // State: "WI",
    // DistributionCenter: "Milwaukee",
    CitiesTowns: "MILWAUKEE",
  },
  "533": {
    // Prefix: "533",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "534": {
    // Prefix: "534",
    // State: "WI",
    // DistributionCenter: "Milwaukee",
    CitiesTowns: "RACINE",
  },
  "535": {
    // Prefix: "535",
    // State: "WI",
    // DistributionCenter: "Madison",
    CitiesTowns: "Beloit, Dodgeville",
  },
  "536": {
    // Prefix: "536",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "537": {
    // Prefix: "537",
    // State: "WI",
    // DistributionCenter: "Madison",
    CitiesTowns: "MADISON",
  },
  "538": {
    // Prefix: "538",
    // State: "WI",
    // DistributionCenter: "Madison",
    CitiesTowns: "Praire du Chien, Platteville",
  },
  "539": {
    // Prefix: "539",
    // State: "WI",
    // DistributionCenter: "Portage",
    CitiesTowns: "<i>Portage</i>, Baraboo",
  },
  "540": {
    // Prefix: "540",
    // State: "WI",
    // DistributionCenter: "St. Paul, MN",
    CitiesTowns: "Hudson, Clayton",
  },
  "541": {
    // Prefix: "541",
    // State: "WI",
    // DistributionCenter: "Green Bay",
    CitiesTowns: "Marinette, De Pere, areas west of Green Bay",
  },
  "542": {
    // Prefix: "542",
    // State: "WI",
    // DistributionCenter: "Green Bay",
    CitiesTowns: "Sturgeon Bay, Manitowoc, areas east of Green Bay",
  },
  "543": {
    // Prefix: "543",
    // State: "WI",
    // DistributionCenter: "Green Bay",
    CitiesTowns: "GREEN BAY",
  },
  "544": {
    // Prefix: "544",
    // State: "WI",
    // DistributionCenter: "Wausau",
    CitiesTowns: "<i>Wausau</i>, Wisconsin Rapids",
  },
  "545": {
    // Prefix: "545",
    // State: "WI",
    // DistributionCenter: "Rhinelander",
    CitiesTowns: "<i>Rhinelander</i>, Eagle River",
  },
  "546": {
    // Prefix: "546",
    // State: "WI",
    // DistributionCenter: "La Crosse",
    CitiesTowns: "<i>La Crosse</i>, Tomah",
  },
  "547": {
    // Prefix: "547",
    // State: "WI",
    // DistributionCenter: "Eau Clare",
    CitiesTowns: "<i>Eau Clare</i>, Menomonie",
  },
  "548": {
    // Prefix: "548",
    // State: "WI",
    // DistributionCenter: "Spooner",
    CitiesTowns: "<i>Spooner</i>, Superior",
  },
  "549": {
    // Prefix: "549",
    // State: "WI",
    // DistributionCenter: "Oshkosh",
    CitiesTowns: "<i>Oshkosh</i>, Fond du Lac",
  },
  "550": {
    // Prefix: "550",
    // State: "MN",
    // DistributionCenter: "St. Paul",
    CitiesTowns: "Red Wing, Pine City, areas around St. Paul",
  },
  "551": {
    // Prefix: "551",
    // State: "MN",
    // DistributionCenter: "St. Paul",
    CitiesTowns: "ST. PAUL",
  },
  "552": {
    // Prefix: "552",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "553": {
    // Prefix: "553",
    // State: "MN",
    // DistributionCenter: "Minneapolis",
    CitiesTowns: "Burnsville, Maple Grove, areas around Minneapolis",
  },
  "554": {
    // Prefix: "554",
    // State: "MN",
    // DistributionCenter: "Minneapolis",
    CitiesTowns: "MINNEAPOLIS",
  },
  "555": {
    // Prefix: "555",
    // State: "MN",
    // DistributionCenter: "Minneapolis",
    CitiesTowns: "Monticello, Young America, areas around Minneapolis",
  },
  "556": {
    // Prefix: "556",
    // State: "MN",
    // DistributionCenter: "Duluth",
    CitiesTowns: "Grand Marais, Two Harbors, far northeastern Minnesota",
  },
  "557": {
    // Prefix: "557",
    // State: "MN",
    // DistributionCenter: "Duluth",
    CitiesTowns: "Grand Rapids, Cloquet, areas around Duluth",
  },
  "558": {
    // Prefix: "558",
    // State: "MN",
    // DistributionCenter: "Duluth",
    CitiesTowns: "DULUTH",
  },
  "559": {
    // Prefix: "559",
    // State: "MN",
    // DistributionCenter: "Rochester",
    CitiesTowns: "<i>Rochester</i>, Winowa",
  },
  "560": {
    // Prefix: "560",
    // State: "MN",
    // DistributionCenter: "Mankato",
    CitiesTowns: "<i>Mankato</i>, Albert Lea",
  },
  "561": {
    // Prefix: "561",
    // State: "MN",
    // DistributionCenter: "Windom",
    CitiesTowns: "<i>Windom</i>, Worthington",
  },
  "562": {
    // Prefix: "562",
    // State: "MN",
    // DistributionCenter: "Willmar",
    CitiesTowns: "<i>Willmar</i>, Morris",
  },
  "563": {
    // Prefix: "563",
    // State: "MN",
    // DistributionCenter: "St. Cloud",
    CitiesTowns: "<i>St. Cloud</i>, Alexandria",
  },
  "564": {
    // Prefix: "564",
    // State: "MN",
    // DistributionCenter: "Branierd",
    CitiesTowns: "<i>Branierd</i>, Wadena",
  },
  "565": {
    // Prefix: "565",
    // State: "MN",
    // DistributionCenter: "Detroit Lakes",
    CitiesTowns: "<i>Detroit Lakes</i>, Moorhead",
  },
  "566": {
    // Prefix: "566",
    // State: "MN",
    // DistributionCenter: "Bemidji",
    CitiesTowns: "<i>Bemidji</i>, International Falls",
  },
  "567": {
    // Prefix: "567",
    // State: "MN",
    // DistributionCenter: "Thief River Falls",
    CitiesTowns: "<i>Thief River Falls</i>, Crookston",
  },
  "568": {
    // Prefix: "568",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "569": {
    // Prefix: "569",
    // State: "DC",
    // DistributionCenter: "Washington",
    CitiesTowns: "Returned mail (following Anthrax scare)",
  },
  "570": {
    // Prefix: "570",
    // State: "SD",
    // DistributionCenter: "Sioux Falls",
    CitiesTowns: "Yankton, Brookings, areas around Sioux Falls",
  },
  "571": {
    // Prefix: "571",
    // State: "SD",
    // DistributionCenter: "Sioux Falls",
    CitiesTowns: "SIOUX FALLS",
  },
  "572": {
    // Prefix: "572",
    // State: "SD",
    // DistributionCenter: "Dakota Central",
    CitiesTowns: "<i>Watertown</i>, Sisseton",
  },
  "573": {
    // Prefix: "573",
    // State: "SD",
    // DistributionCenter: "Dakota Central",
    CitiesTowns: "<i>Mitchell</i>, Huron",
  },
  "574": {
    // Prefix: "574",
    // State: "SD",
    // DistributionCenter: "Aberdeen",
    CitiesTowns: "<i>Aberdeen</i>, Gettsyburg",
  },
  "575": {
    // Prefix: "575",
    // State: "SD",
    // DistributionCenter: "Pierre",
    CitiesTowns: "<i>Pierre</i>, Winner",
  },
  "576": {
    // Prefix: "576",
    // State: "SD",
    // DistributionCenter: "Mobridge",
    CitiesTowns: "<i>Mobridge</i>, Lemmon",
  },
  "577": {
    // Prefix: "577",
    // State: "SD",
    // DistributionCenter: "Rapid City",
    CitiesTowns: "<i>Rapid City</i>, Hot Springs",
  },
  "578": {
    // Prefix: "578",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "579": {
    // Prefix: "579",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "580": {
    // Prefix: "580",
    // State: "ND",
    // DistributionCenter: "Fargo",
    CitiesTowns: "Valley City, Wahpeton, areas around Fargo",
  },
  "581": {
    // Prefix: "581",
    // State: "ND",
    // DistributionCenter: "Fargo",
    CitiesTowns: "FARGO",
  },
  "582": {
    // Prefix: "582",
    // State: "ND",
    // DistributionCenter: "Grand Forks",
    CitiesTowns: "<i>Grand Forks</i>, Pembina",
  },
  "583": {
    // Prefix: "583",
    // State: "ND",
    // DistributionCenter: "Devils Lake",
    CitiesTowns: "<i>Devils Lake</i>, Bottineau",
  },
  "584": {
    // Prefix: "584",
    // State: "ND",
    // DistributionCenter: "Jamestown",
    CitiesTowns: "<i>Jamestown</i>, Fessenden",
  },
  "585": {
    // Prefix: "585",
    // State: "ND",
    // DistributionCenter: "Bismarck",
    CitiesTowns: "<i>Bismarck</i>, Mandan",
  },
  "586": {
    // Prefix: "586",
    // State: "ND",
    // DistributionCenter: "Dickenson",
    CitiesTowns: "<i>Dickenson</i>, Bowman",
  },
  "587": {
    // Prefix: "587",
    // State: "ND",
    // DistributionCenter: "Minot",
    CitiesTowns: "<i>Minot</i>, Bowbells",
  },
  "588": {
    // Prefix: "588",
    // State: "ND",
    // DistributionCenter: "Williston",
    CitiesTowns: "<i>Williston</i>, Watford City",
  },
  "589": {
    // Prefix: "589",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "590": {
    // Prefix: "590",
    // State: "MT",
    // DistributionCenter: "Billings",
    CitiesTowns: "Laurel, Livingston, areas around Billings",
  },
  "591": {
    // Prefix: "591",
    // State: "MT",
    // DistributionCenter: "Billings",
    CitiesTowns: "BILLINGS",
  },
  "592": {
    // Prefix: "592",
    // State: "MT",
    // DistributionCenter: "Wolf Point",
    CitiesTowns: "<i>Wolf Point</i>, Sidney",
  },
  "593": {
    // Prefix: "593",
    // State: "MT",
    // DistributionCenter: "Miles City",
    CitiesTowns: "<i>Miles City</i>, Glendive",
  },
  "594": {
    // Prefix: "594",
    // State: "MT",
    // DistributionCenter: "Great Falls",
    CitiesTowns: "<i>Great Falls</i>, Cut Bank",
  },
  "595": {
    // Prefix: "595",
    // State: "MT",
    // DistributionCenter: "Havre",
    CitiesTowns: "<i>Havre</i>, Malta",
  },
  "596": {
    // Prefix: "596",
    // State: "MT",
    // DistributionCenter: "Helena",
    CitiesTowns: "<i>Helena</i>, Townsend",
  },
  "597": {
    // Prefix: "597",
    // State: "MT",
    // DistributionCenter: "Butte",
    CitiesTowns: "<i>Butte</i>, Bozeman",
  },
  "598": {
    // Prefix: "598",
    // State: "MT",
    // DistributionCenter: "Missoula",
    CitiesTowns: "<i>Missoula</i>, Hamilton",
  },
  "599": {
    // Prefix: "599",
    // State: "MT",
    // DistributionCenter: "Kalispell",
    CitiesTowns: "<i>Kalispell</i>, Malta",
  },
  "600": {
    // Prefix: "600",
    // State: "IL",
    // DistributionCenter: "Palatine",
    CitiesTowns: "Waukegan, Elgin, northern Chicago suburbs",
  },
  "601": {
    // Prefix: "601",
    // State: "IL",
    // DistributionCenter: "Carol Stream",
    CitiesTowns: "Carol Stream, DeKalb, northwestern Chicago suburbs",
  },
  "602": {
    // Prefix: "602",
    // State: "IL",
    // DistributionCenter: "Palatine",
    CitiesTowns: "EVANSTON",
  },
  "603": {
    // Prefix: "603",
    // State: "IL",
    // DistributionCenter: "Carol Stream",
    CitiesTowns: "OAK PARK",
  },
  "604": {
    // Prefix: "604",
    // State: "IL",
    // DistributionCenter: "Chicago",
    CitiesTowns: "Joliet, Oak Lawn, southern Chicago suburbs",
  },
  "605": {
    // Prefix: "605",
    // State: "IL",
    // DistributionCenter: "Fox Valley",
    CitiesTowns: "Aurora, Naperville, <i>Summit</i>, western Chicago suburbs",
  },
  "606": {
    // Prefix: "606",
    // State: "IL",
    // DistributionCenter: "Chicago",
    CitiesTowns: "CHICAGO",
  },
  "607": {
    // Prefix: "607",
    // State: "IL",
    // DistributionCenter: "Chicago",
    CitiesTowns: "CHICAGO, Niles",
  },
  "608": {
    // Prefix: "608",
    // State: "IL",
    // DistributionCenter: "Chicago",
    CitiesTowns: "Cicero, Riverdale",
  },
  "609": {
    // Prefix: "609",
    // State: "IL",
    // DistributionCenter: "Kankakee",
    CitiesTowns: "<i>Kankakee</i>, Watseka",
  },
  "610": {
    // Prefix: "610",
    // State: "IL",
    // DistributionCenter: "Rockford",
    CitiesTowns: "Rochelle, Freeport, areas around Rockford",
  },
  "611": {
    // Prefix: "611",
    // State: "IL",
    // DistributionCenter: "Rockford",
    CitiesTowns: "ROCKFORD",
  },
  "612": {
    // Prefix: "612",
    // State: "IL",
    // DistributionCenter: "Rock Island",
    CitiesTowns: "<i>Rock Island</i>, Moline",
  },
  "613": {
    // Prefix: "613",
    // State: "IL",
    // DistributionCenter: "La Salle",
    CitiesTowns: "<i>La Salle</i>, Streator",
  },
  "614": {
    // Prefix: "614",
    // State: "IL",
    // DistributionCenter: "Galesburg",
    CitiesTowns: "<i>Galesburg</i>, Macomb",
  },
  "615": {
    // Prefix: "615",
    // State: "IL",
    // DistributionCenter: "Peoria",
    CitiesTowns: "Pekin, Canton, areas around Peoria",
  },
  "616": {
    // Prefix: "616",
    // State: "IL",
    // DistributionCenter: "Peoria",
    CitiesTowns: "PEORIA",
  },
  "617": {
    // Prefix: "617",
    // State: "IL",
    // DistributionCenter: "Bloomington",
    CitiesTowns: "<i>Bloomington</i>, Pontiac",
  },
  "618": {
    // Prefix: "618",
    // State: "IL",
    // DistributionCenter: "Champaign",
    CitiesTowns: "<i>Champaign</i>, Danville",
  },
  "619": {
    // Prefix: "619",
    // State: "IL",
    // DistributionCenter: "Champaign",
    CitiesTowns: "Mattoon, Paris",
  },
  "620": {
    // Prefix: "620",
    // State: "IL",
    // DistributionCenter: "St. Louis, MO",
    CitiesTowns: "Alton, Litchfield, St. Louis Suburbs",
  },
  "621": {
    // Prefix: "621",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "622": {
    // Prefix: "622",
    // State: "IL",
    // DistributionCenter: "St. Louis, MO",
    CitiesTowns: "<i>East St. Louis</i>, Belleville, St. Louis Suburbs",
  },
  "623": {
    // Prefix: "623",
    // State: "IL",
    // DistributionCenter: "Quincy",
    CitiesTowns: "<i>Quincy</i>, Carthage",
  },
  "624": {
    // Prefix: "624",
    // State: "IL",
    // DistributionCenter: "Effingham",
    CitiesTowns: "<i>Effingham</i>, Vandalia",
  },
  "625": {
    // Prefix: "625",
    // State: "IL",
    // DistributionCenter: "Springfield",
    CitiesTowns: "Decatur, Taylorsville, areas south of Springfield",
  },
  "626": {
    // Prefix: "626",
    // State: "IL",
    // DistributionCenter: "Springfield",
    CitiesTowns: "Lincoln, Jacksonville, areas north of Springfield",
  },
  "627": {
    // Prefix: "627",
    // State: "IL",
    // DistributionCenter: "Springfield",
    CitiesTowns: "SPRINGFIELD",
  },
  "628": {
    // Prefix: "628",
    // State: "IL",
    // DistributionCenter: "Centralia",
    CitiesTowns: "<i>Centralia</i>, Mount Vernon",
  },
  "629": {
    // Prefix: "629",
    // State: "IL",
    // DistributionCenter: "Carbondale",
    CitiesTowns: "<i>Carbondale</i>, Cairo",
  },
  "630": {
    // Prefix: "630",
    // State: "MO",
    // DistributionCenter: "St. Louis",
    CitiesTowns: "Kirkwood, Washington, areas south of St. Louis",
  },
  "631": {
    // Prefix: "631",
    // State: "MO",
    // DistributionCenter: "St. Louis",
    CitiesTowns: "ST. LOUIS",
  },
  "632": {
    // Prefix: "632",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "633": {
    // Prefix: "633",
    // State: "MO",
    // DistributionCenter: "St. Louis",
    CitiesTowns: "<i>St. Charles</i>, St. Peters, areas north of St. Louis",
  },
  "634": {
    // Prefix: "634",
    // State: "MO",
    // DistributionCenter: "Quincy, IL",
    CitiesTowns: "<i>Hannibal</i>, Kahoika",
  },
  "635": {
    // Prefix: "635",
    // State: "MO",
    // DistributionCenter: "Quincy, IL",
    CitiesTowns: "<i>Kirksville</i>, Macon",
  },
  "636": {
    // Prefix: "636",
    // State: "MO",
    // DistributionCenter: "Cape Girardeau",
    CitiesTowns: "Farmington, <i>Park Hills</i>, Potosi",
  },
  "637": {
    // Prefix: "637",
    // State: "MO",
    // DistributionCenter: "Cape Girardeau",
    CitiesTowns: "<i>Cape Girardeau</i>, Perryville",
  },
  "638": {
    // Prefix: "638",
    // State: "MO",
    // DistributionCenter: "Cape Girardeau",
    CitiesTowns: "<i>Sikeston</i>, Kennett",
  },
  "639": {
    // Prefix: "639",
    // State: "MO",
    // DistributionCenter: "Cape Girardeau",
    CitiesTowns: "<i>Poplar Bluff</i>, Van Buren",
  },
  "640": {
    // Prefix: "640",
    // State: "MO",
    // DistributionCenter: "Kansas City",
    CitiesTowns: "Independence, Warrensburg, areas around Kansas City",
  },
  "641": {
    // Prefix: "641",
    // State: "MO",
    // DistributionCenter: "Kansas City",
    CitiesTowns: "KANSAS CITY",
  },
  "642": {
    // Prefix: "642",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "643": {
    // Prefix: "643",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "644": {
    // Prefix: "644",
    // State: "MO",
    // DistributionCenter: "St. Joseph",
    CitiesTowns: "Maryville, Cameron, areas around St. Joseph",
  },
  "645": {
    // Prefix: "645",
    // State: "MO",
    // DistributionCenter: "St. Joseph",
    CitiesTowns: "ST. JOSEPH",
  },
  "646": {
    // Prefix: "646",
    // State: "MO",
    // DistributionCenter: "Chillicothe",
    CitiesTowns: "<i>Chillicothe</i>, Brookfield",
  },
  "647": {
    // Prefix: "647",
    // State: "MO",
    // DistributionCenter: "Harrisonville",
    CitiesTowns: "<i>Harrisonville</i>, Nevada",
  },
  "648": {
    // Prefix: "648",
    // State: "MO",
    // DistributionCenter: "Springfield",
    CitiesTowns: "<i>Joplin</i>, Neosho",
  },
  "649": {
    // Prefix: "649",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "650": {
    // Prefix: "650",
    // State: "MO",
    // DistributionCenter: "Mid-Missouri",
    CitiesTowns: "Osage Beach, California, areas around Jefferson City",
  },
  "651": {
    // Prefix: "651",
    // State: "MO",
    // DistributionCenter: "Mid-Missouri",
    CitiesTowns: "JEFFERSON CITY",
  },
  "652": {
    // Prefix: "652",
    // State: "MO",
    // DistributionCenter: "Mid-Missouri",
    CitiesTowns: "<i>Columbia</i>, Moberly",
  },
  "653": {
    // Prefix: "653",
    // State: "MO",
    // DistributionCenter: "Mid-Missouri",
    CitiesTowns: "<i>Sedalia</i>, Marshall",
  },
  "654": {
    // Prefix: "654",
    // State: "MO",
    // DistributionCenter: "Springfield",
    CitiesTowns: "<i>Rolla</i>, Houston, areas around Rolla A-I",
  },
  "655": {
    // Prefix: "655",
    // State: "MO",
    // DistributionCenter: "Springfield",
    CitiesTowns: "Lebanon, Waynesville, areas around Rolla J-Z",
  },
  "656": {
    // Prefix: "656",
    // State: "MO",
    // DistributionCenter: "Springfield",
    CitiesTowns: "Branson, Bolivar, areas around Springfield A-L",
  },
  "657": {
    // Prefix: "657",
    // State: "MO",
    // DistributionCenter: "Springfield",
    CitiesTowns: "West Plains, Monett, areas around Springfield M-Z",
  },
  "658": {
    // Prefix: "658",
    // State: "MO",
    // DistributionCenter: "Springfield",
    CitiesTowns: "SPRINGFIELD",
  },
  "659": {
    // Prefix: "659",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "660": {
    // Prefix: "660",
    // State: "KS",
    // DistributionCenter: "Kansas City",
    CitiesTowns: "Lawrence, Olathe",
  },
  "661": {
    // Prefix: "661",
    // State: "KS",
    // DistributionCenter: "Kansas City",
    CitiesTowns: "KANSAS CITY",
  },
  "662": {
    // Prefix: "662",
    // State: "KS",
    // DistributionCenter: "Kansas City",
    CitiesTowns: "SHAWNEE MISSION",
  },
  "663": {
    // Prefix: "663",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "664": {
    // Prefix: "664",
    // State: "KS",
    // DistributionCenter: "Topeka",
    CitiesTowns: "Junction City, Hiawatha, areas around Topeka A-L",
  },
  "665": {
    // Prefix: "665",
    // State: "KS",
    // DistributionCenter: "Topeka",
    CitiesTowns: "Manhattan, Marysville, areas around Topeka M-Z",
  },
  "666": {
    // Prefix: "666",
    // State: "KS",
    // DistributionCenter: "Topeka",
    CitiesTowns: "TOPEKA",
  },
  "667": {
    // Prefix: "667",
    // State: "KS",
    // DistributionCenter: "Fort Scott",
    CitiesTowns: "<i>Fort Scott</i>, Iola",
  },
  "668": {
    // Prefix: "668",
    // State: "KS",
    // DistributionCenter: "Emporia",
    CitiesTowns: "<i>Emporia</i>, Council Grove",
  },
  "669": {
    // Prefix: "669",
    // State: "KS",
    // DistributionCenter: "Salina",
    CitiesTowns: "<i>Concordia</i>, Washington",
  },
  "670": {
    // Prefix: "670",
    // State: "KS",
    // DistributionCenter: "Wichita",
    CitiesTowns: "Arkansas City, El Dorado, areas around Wichita A-L",
  },
  "671": {
    // Prefix: "671",
    // State: "KS",
    // DistributionCenter: "Wichita",
    CitiesTowns: "Newton, Pratt, areas around Wichita M-Z",
  },
  "672": {
    // Prefix: "672",
    // State: "KS",
    // DistributionCenter: "Wichita",
    CitiesTowns: "WICHITA",
  },
  "673": {
    // Prefix: "673",
    // State: "KS",
    // DistributionCenter: "Independence",
    CitiesTowns: "<i>Independence</i>, Parsons",
  },
  "674": {
    // Prefix: "674",
    // State: "KS",
    // DistributionCenter: "Salina",
    CitiesTowns: "<i>Salina</i>, McPherson",
  },
  "675": {
    // Prefix: "675",
    // State: "KS",
    // DistributionCenter: "Hutchinson",
    CitiesTowns: "<i>Hutchinson</i>, Great Bend",
  },
  "676": {
    // Prefix: "676",
    // State: "KS",
    // DistributionCenter: "Hays",
    CitiesTowns: "<i>Hays</i>, Norton",
  },
  "677": {
    // Prefix: "677",
    // State: "KS",
    // DistributionCenter: "Colby",
    CitiesTowns: "<i>Colby</i>, Goodland",
  },
  "678": {
    // Prefix: "678",
    // State: "KS",
    // DistributionCenter: "Dodge City",
    CitiesTowns: "<i>Dodge City</i>, Garden City",
  },
  "679": {
    // Prefix: "679",
    // State: "KS",
    // DistributionCenter: "Liberal",
    CitiesTowns: "<i>Liberal</i>, Elkhart",
  },
  "680": {
    // Prefix: "680",
    // State: "NE",
    // DistributionCenter: "Omaha",
    CitiesTowns: "<i>Fremont</i>, Plattsmouth, areas around Omaha",
  },
  "681": {
    // Prefix: "681",
    // State: "NE",
    // DistributionCenter: "Omaha",
    CitiesTowns: "OMAHA",
  },
  "682": {
    // Prefix: "682",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "683": {
    // Prefix: "683",
    // State: "NE",
    // DistributionCenter: "Lincoln",
    CitiesTowns: "Beatrice, Falls City, areas around Lincoln A-L",
  },
  "684": {
    // Prefix: "684",
    // State: "NE",
    // DistributionCenter: "Lincoln",
    CitiesTowns: "York, Nebraska City, areas around Lincoln M-Z",
  },
  "685": {
    // Prefix: "685",
    // State: "NE",
    // DistributionCenter: "Lincoln",
    CitiesTowns: "LINCOLN",
  },
  "686": {
    // Prefix: "686",
    // State: "NE",
    // DistributionCenter: "Columbus",
    CitiesTowns: "<i>Columbus</i>, Fullerton",
  },
  "687": {
    // Prefix: "687",
    // State: "NE",
    // DistributionCenter: "Norfolk",
    CitiesTowns: "<i>Norfolk</i>, O'Neill",
  },
  "688": {
    // Prefix: "688",
    // State: "NE",
    // DistributionCenter: "Grand Island",
    CitiesTowns: "<i>Grand Island</i>, Kearney",
  },
  "689": {
    // Prefix: "689",
    // State: "NE",
    // DistributionCenter: "Grand Island",
    CitiesTowns: "<i>Hastings</i>, Holdridge",
  },
  "690": {
    // Prefix: "690",
    // State: "NE",
    // DistributionCenter: "McCook",
    CitiesTowns: "<i>McCook</i>, Imperial",
  },
  "691": {
    // Prefix: "691",
    // State: "NE",
    // DistributionCenter: "North Platte",
    CitiesTowns: "<i>North Platte</i>, Sidney",
  },
  "692": {
    // Prefix: "692",
    // State: "NE",
    // DistributionCenter: "Valentine",
    CitiesTowns: "<i>Valentine</i>, Ainsworth",
  },
  "693": {
    // Prefix: "693",
    // State: "NE",
    // DistributionCenter: "Alliance",
    CitiesTowns: "<i>Alliance</i>, Scottsbluff",
  },
  "694": {
    // Prefix: "694",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "695": {
    // Prefix: "695",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "696": {
    // Prefix: "696",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "697": {
    // Prefix: "697",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "698": {
    // Prefix: "698",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "699": {
    // Prefix: "699",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "700": {
    // Prefix: "700",
    // State: "LA",
    // DistributionCenter: "New Orleans",
    CitiesTowns: "Metarie, Chalmette, areas around New Orleans",
  },
  "701": {
    // Prefix: "701",
    // State: "LA",
    // DistributionCenter: "New Orleans",
    CitiesTowns: "NEW ORLEANS",
  },
  "702": {
    // Prefix: "702",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "703": {
    // Prefix: "703",
    // State: "LA",
    // DistributionCenter: "Houma",
    CitiesTowns: "Houma, <i>Thibodaux</i>, Morgan City",
  },
  "704": {
    // Prefix: "704",
    // State: "LA",
    // DistributionCenter: "Mandeville",
    CitiesTowns: "<i>Hammond</i>, Slidell",
  },
  "705": {
    // Prefix: "705",
    // State: "LA",
    // DistributionCenter: "Lafayette",
    CitiesTowns: "<i>Lafayette</i>, Jennings",
  },
  "706": {
    // Prefix: "706",
    // State: "LA",
    // DistributionCenter: "Lake Charles",
    CitiesTowns: "<i>Lake Charles</i>, DeRidder",
  },
  "707": {
    // Prefix: "707",
    // State: "LA",
    // DistributionCenter: "Baton Rouge",
    CitiesTowns: "Port Allen, Gonzales",
  },
  "708": {
    // Prefix: "708",
    // State: "LA",
    // DistributionCenter: "Baton Rouge",
    CitiesTowns: "BATON ROUGE",
  },
  "709": {
    // Prefix: "709",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "710": {
    // Prefix: "710",
    // State: "LA",
    // DistributionCenter: "Shreveport",
    CitiesTowns: "Bossier City, Minden, areas around Shreveport",
  },
  "711": {
    // Prefix: "711",
    // State: "LA",
    // DistributionCenter: "Shreveport",
    CitiesTowns: "SHREVEPORT",
  },
  "712": {
    // Prefix: "712",
    // State: "LA",
    // DistributionCenter: "Monroe",
    CitiesTowns: "<i>Monroe</i>, Ruston",
  },
  "713": {
    // Prefix: "713",
    // State: "LA",
    // DistributionCenter: "Alexandria",
    CitiesTowns: "<i>Alexandria</i>, Vidalia",
  },
  "714": {
    // Prefix: "714",
    // State: "LA",
    // DistributionCenter: "Alexandria",
    CitiesTowns: "Natchitoches, Winnfield",
  },
  "715": {
    // Prefix: "715",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "716": {
    // Prefix: "716",
    // State: "AR",
    // DistributionCenter: "Pine Bluff",
    CitiesTowns: "<i>Pine Bluff</i>, Monticello",
  },
  "717": {
    // Prefix: "717",
    // State: "AR",
    // DistributionCenter: "Camden",
    CitiesTowns: "<i>Camden</i>, El Dorado",
  },
  "718": {
    // Prefix: "718",
    // State: "AR",
    // DistributionCenter: "Texarkana, TX",
    CitiesTowns: "Texarkana, <i>Hope</i>",
  },
  "719": {
    // Prefix: "719",
    // State: "AR",
    // DistributionCenter: "Hot Springs",
    CitiesTowns: "<i>Hot Springs</i>, Mena",
  },
  "720": {
    // Prefix: "720",
    // State: "AR",
    // DistributionCenter: "Little Rock",
    CitiesTowns: "Conway, Benton, areas around Little Rock A-L",
  },
  "721": {
    // Prefix: "721",
    // State: "AR",
    // DistributionCenter: "Little Rock",
    CitiesTowns: "Searcy, Stuttgart, areas around Little Rock",
  },
  "722": {
    // Prefix: "722",
    // State: "AR",
    // DistributionCenter: "Little Rock",
    CitiesTowns: "LITTLE ROCK",
  },
  "723": {
    // Prefix: "723",
    // State: "AR",
    // DistributionCenter: "Memphis, TN",
    CitiesTowns: "<i>West Memphis</i>, Forrest City, Blytheville",
  },
  "724": {
    // Prefix: "724",
    // State: "AR",
    // DistributionCenter: "Jonesboro",
    CitiesTowns: "<i>Jonesboro</i>, Pargould",
  },
  "725": {
    // Prefix: "725",
    // State: "AR",
    // DistributionCenter: "Batesville",
    CitiesTowns: "<i>Batesville</i>, Heber Springs",
  },
  "726": {
    // Prefix: "726",
    // State: "AR",
    // DistributionCenter: "Harrison",
    CitiesTowns: "<i>Harrison</i>, Mountain Home",
  },
  "727": {
    // Prefix: "727",
    // State: "AR",
    // DistributionCenter: "Fayetteville",
    CitiesTowns: "<i>Fayetteville</i>, Rogers",
  },
  "728": {
    // Prefix: "728",
    // State: "AR",
    // DistributionCenter: "Russellville",
    CitiesTowns: "<i>Russellville</i>, Clarksville",
  },
  "729": {
    // Prefix: "729",
    // State: "AR",
    // DistributionCenter: "Fort Smith",
    CitiesTowns: "<i>Fort Smith</i>, Ozark",
  },
  "730": {
    // Prefix: "730",
    // State: "OK",
    // DistributionCenter: "Oklahoma City",
    CitiesTowns: "Norman, Edmond, areas around Oklahoma City",
  },
  "731": {
    // Prefix: "731",
    // State: "OK",
    // DistributionCenter: "Oklahoma City",
    CitiesTowns: "OKLAHOMA CITY",
  },
  "732": {
    // Prefix: "732",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "733": {
    // Prefix: "733",
    // State: "TX",
    // DistributionCenter: "Austin",
    CitiesTowns: "IRS",
  },
  "734": {
    // Prefix: "734",
    // State: "OK",
    // DistributionCenter: "Ardmore",
    CitiesTowns: "<i>Ardmore</i>, Tishomingo",
  },
  "735": {
    // Prefix: "735",
    // State: "OK",
    // DistributionCenter: "Lawton",
    CitiesTowns: "<i>Lawton</i>, Altus",
  },
  "736": {
    // Prefix: "736",
    // State: "OK",
    // DistributionCenter: "Clinton",
    CitiesTowns: "<i>Clinton</i>, Elk City",
  },
  "737": {
    // Prefix: "737",
    // State: "OK",
    // DistributionCenter: "Enid",
    CitiesTowns: "<i>Enid</i>, Alva",
  },
  "738": {
    // Prefix: "738",
    // State: "OK",
    // DistributionCenter: "Woodward",
    CitiesTowns: "<i>Woodward</i>, Buffalo",
  },
  "739": {
    // Prefix: "739",
    // State: "OK",
    // DistributionCenter: "Liberal, KS",
    CitiesTowns: "Guymon, Boise City",
  },
  "740": {
    // Prefix: "740",
    // State: "OK",
    // DistributionCenter: "Tulsa",
    CitiesTowns: "Bartlesville, Stillwater, areas around Tulsa",
  },
  "741": {
    // Prefix: "741",
    // State: "OK",
    // DistributionCenter: "Tulsa",
    CitiesTowns: "TULSA",
  },
  "742": {
    // Prefix: "742",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "743": {
    // Prefix: "743",
    // State: "OK",
    // DistributionCenter: "Tulsa",
    CitiesTowns: "<i>Vinta</i>, Miami",
  },
  "744": {
    // Prefix: "744",
    // State: "OK",
    // DistributionCenter: "Muskogee",
    CitiesTowns: "<i>Muskogee</i>, Henryetta",
  },
  "745": {
    // Prefix: "745",
    // State: "OK",
    // DistributionCenter: "McAlester",
    CitiesTowns: "<i>McAlester</i>, Atoka",
  },
  "746": {
    // Prefix: "746",
    // State: "OK",
    // DistributionCenter: "Ponca City",
    CitiesTowns: "<i>Ponca City</i>, Blackwell",
  },
  "747": {
    // Prefix: "747",
    // State: "OK",
    // DistributionCenter: "Durant",
    CitiesTowns: "<i>Durant</i>, Idabel",
  },
  "748": {
    // Prefix: "748",
    // State: "OK",
    // DistributionCenter: "Shawnee",
    CitiesTowns: "<i>Shawnee</i>, Ada",
  },
  "749": {
    // Prefix: "749",
    // State: "OK",
    // DistributionCenter: "Poteau",
    CitiesTowns: "Poteau, Sallisaw",
  },
  "750": {
    // Prefix: "750",
    // State: "TX",
    // DistributionCenter: "North Texas",
    CitiesTowns: "Plano, Sherman, areas north of Dallas",
  },
  "751": {
    // Prefix: "751",
    // State: "TX",
    // DistributionCenter: "Dallas",
    CitiesTowns: "Mesquite, Corsicana, areas south of Dallas",
  },
  "752": {
    // Prefix: "752",
    // State: "TX",
    // DistributionCenter: "Dallas",
    CitiesTowns: "DALLAS",
  },
  "753": {
    // Prefix: "753",
    // State: "TX",
    // DistributionCenter: "Dallas",
    CitiesTowns: "DALLAS",
  },
  "754": {
    // Prefix: "754",
    // State: "TX",
    // DistributionCenter: "Greenville",
    CitiesTowns: "<i>Greenville</i>, Paris",
  },
  "755": {
    // Prefix: "755",
    // State: "TX",
    // DistributionCenter: "Texarkana",
    CitiesTowns: "<i>Texarkana</i>, New Boston",
  },
  "756": {
    // Prefix: "756",
    // State: "TX",
    // DistributionCenter: "Longview",
    CitiesTowns: "<i>Longview</i>, Marshall",
  },
  "757": {
    // Prefix: "757",
    // State: "TX",
    // DistributionCenter: "Tyler",
    CitiesTowns: "<i>Tyler</i>, Athens",
  },
  "758": {
    // Prefix: "758",
    // State: "TX",
    // DistributionCenter: "Palestine",
    CitiesTowns: "<i>Palestine</i>, Crockett",
  },
  "759": {
    // Prefix: "759",
    // State: "TX",
    // DistributionCenter: "Lufkin",
    CitiesTowns: "<i>Lufkin</i>, Jasper",
  },
  "760": {
    // Prefix: "760",
    // State: "TX",
    // DistributionCenter: "Fort Worth",
    CitiesTowns: "Arlington, Cleburne, areas around Fort Worrg",
  },
  "761": {
    // Prefix: "761",
    // State: "TX",
    // DistributionCenter: "Fort Worth",
    CitiesTowns: "FORT WORTH",
  },
  "762": {
    // Prefix: "762",
    // State: "TX",
    // DistributionCenter: "Fort Worth",
    CitiesTowns: "<i>Denton</i>, Gainesville",
  },
  "763": {
    // Prefix: "763",
    // State: "TX",
    // DistributionCenter: "Wichita Falls",
    CitiesTowns: "Wichita Falls, Vernon",
  },
  "764": {
    // Prefix: "764",
    // State: "TX",
    // DistributionCenter: "Fort Worth",
    CitiesTowns: "<i>Stephenville</i>, Breckenridge",
  },
  "765": {
    // Prefix: "765",
    // State: "TX",
    // DistributionCenter: "Waco",
    CitiesTowns: "<i>Temple</i>, Killeen",
  },
  "766": {
    // Prefix: "766",
    // State: "TX",
    // DistributionCenter: "Waco",
    CitiesTowns: "Hillsboro, Mexia, areas around Waco",
  },
  "767": {
    // Prefix: "767",
    // State: "TX",
    // DistributionCenter: "Waco",
    CitiesTowns: "WACO",
  },
  "768": {
    // Prefix: "768",
    // State: "TX",
    // DistributionCenter: "Abeline",
    CitiesTowns: "<i>Brownwood</i>, Brady",
  },
  "769": {
    // Prefix: "769",
    // State: "TX",
    // DistributionCenter: "Midland",
    CitiesTowns: "<i>San Angelo</i>, Sonora",
  },
  "770": {
    // Prefix: "770",
    // State: "TX",
    // DistributionCenter: "Houston",
    CitiesTowns: "HOUSTON",
  },
  "771": {
    // Prefix: "771",
    // State: "TX",
    // DistributionCenter: "Houston",
    CitiesTowns: "HOUSTON",
  },
  "772": {
    // Prefix: "772",
    // State: "TX",
    // DistributionCenter: "Houston",
    CitiesTowns: "HOUSTON",
  },
  "773": {
    // Prefix: "773",
    // State: "TX",
    // DistributionCenter: "North Houston",
    CitiesTowns: "Huntsville, <i>Conroe</i>, areas north of Houston",
  },
  "774": {
    // Prefix: "774",
    // State: "TX",
    // DistributionCenter: "North Houston",
    CitiesTowns: "Bay City, Katy, areas west of Houston",
  },
  "775": {
    // Prefix: "775",
    // State: "TX",
    // DistributionCenter: "North Houston",
    CitiesTowns: "Galveston, <i>Pasadena</i>, areas south of Houston",
  },
  "776": {
    // Prefix: "776",
    // State: "TX",
    // DistributionCenter: "Beaumont",
    CitiesTowns: "Orange, Port Arthur, areas around Beaumont",
  },
  "777": {
    // Prefix: "777",
    // State: "TX",
    // DistributionCenter: "Beaumont",
    CitiesTowns: "BEAUMONT",
  },
  "778": {
    // Prefix: "778",
    // State: "TX",
    // DistributionCenter: "Bryan",
    CitiesTowns: "<i>Bryan</i>, College Station",
  },
  "779": {
    // Prefix: "779",
    // State: "TX",
    // DistributionCenter: "Victoria",
    CitiesTowns: "<i>Victoria</i>, Cuero",
  },
  "780": {
    // Prefix: "780",
    // State: "TX",
    // DistributionCenter: "San Antonio",
    CitiesTowns: "Laredo, Kerrville, areas west of San Antonio",
  },
  "781": {
    // Prefix: "781",
    // State: "TX",
    // DistributionCenter: "San Antonio",
    CitiesTowns: "Beeville, New Braunfels, areas east of San Antonio",
  },
  "782": {
    // Prefix: "782",
    // State: "TX",
    // DistributionCenter: "San Antonio",
    CitiesTowns: "SAN ANTONIO",
  },
  "783": {
    // Prefix: "783",
    // State: "TX",
    // DistributionCenter: "Corpus Christi",
    CitiesTowns: "Rockport, Alice, areas around Corpus Christi",
  },
  "784": {
    // Prefix: "784",
    // State: "TX",
    // DistributionCenter: "Corpus Christi",
    CitiesTowns: "CORPUS CHRISTI",
  },
  "785": {
    // Prefix: "785",
    // State: "TX",
    // DistributionCenter: "McAllen",
    CitiesTowns: "<i>McAllen</i>, Brownsville",
  },
  "786": {
    // Prefix: "786",
    // State: "TX",
    // DistributionCenter: "Austin",
    CitiesTowns: "San Marcos, Fredericksburg, areas around Austin",
  },
  "787": {
    // Prefix: "787",
    // State: "TX",
    // DistributionCenter: "Austin",
    CitiesTowns: "AUSTIN",
  },
  "788": {
    // Prefix: "788",
    // State: "TX",
    // DistributionCenter: "San Antonio",
    CitiesTowns: "<i>Uvalde</i>, Del Rio",
  },
  "789": {
    // Prefix: "789",
    // State: "TX",
    // DistributionCenter: "Austin",
    CitiesTowns: "Giddings, Columbus",
  },
  "790": {
    // Prefix: "790",
    // State: "TX",
    // DistributionCenter: "Amarillo",
    CitiesTowns: "Dalhart, Plainview",
  },
  "791": {
    // Prefix: "791",
    // State: "TX",
    // DistributionCenter: "Amarillo",
    CitiesTowns: "AMARILLO",
  },
  "792": {
    // Prefix: "792",
    // State: "TX",
    // DistributionCenter: "Childress",
    CitiesTowns: "Childress, Guthrie",
  },
  "793": {
    // Prefix: "793",
    // State: "TX",
    // DistributionCenter: "Lubbock",
    CitiesTowns: "Brownfield, Post, areas around Lubbock",
  },
  "794": {
    // Prefix: "794",
    // State: "TX",
    // DistributionCenter: "Lubbock",
    CitiesTowns: "LUBBOCK",
  },
  "795": {
    // Prefix: "795",
    // State: "TX",
    // DistributionCenter: "Abilene",
    CitiesTowns: "Sweetwater, Haskell, areas around Abilene",
  },
  "796": {
    // Prefix: "796",
    // State: "TX",
    // DistributionCenter: "Abilene",
    CitiesTowns: "ABILENE",
  },
  "797": {
    // Prefix: "797",
    // State: "TX",
    // DistributionCenter: "Midland",
    CitiesTowns: "<i>Midland</i>, Odessa, Big Spring",
  },
  "798": {
    // Prefix: "798",
    // State: "TX",
    // DistributionCenter: "El Paso",
    CitiesTowns: "Van Horn, Alpine, areas around El Paso",
  },
  "799": {
    // Prefix: "799",
    // State: "TX",
    // DistributionCenter: "El Paso",
    CitiesTowns: "EL PASO",
  },
  "800": {
    // Prefix: "800",
    // State: "CO",
    // DistributionCenter: "Denver",
    CitiesTowns: "Aurora, Arvada, areas north of Denver",
  },
  "801": {
    // Prefix: "801",
    // State: "CO",
    // DistributionCenter: "Denver",
    CitiesTowns: "Littleton, Castle Rock, areas around Denver",
  },
  "802": {
    // Prefix: "802",
    // State: "CO",
    // DistributionCenter: "Denver",
    CitiesTowns: "DENVER",
  },
  "803": {
    // Prefix: "803",
    // State: "CO",
    // DistributionCenter: "Denver",
    CitiesTowns: "BOULDER",
  },
  "804": {
    // Prefix: "804",
    // State: "CO",
    // DistributionCenter: "Denver",
    CitiesTowns: "<i>Golden</i>, Steamboat Springs",
  },
  "805": {
    // Prefix: "805",
    // State: "CO",
    // DistributionCenter: "Longmont",
    CitiesTowns: "<i>Longmont</i>, Fort Collins",
  },
  "806": {
    // Prefix: "806",
    // State: "CO",
    // DistributionCenter: "Brighton",
    CitiesTowns: "<i>Brighton</i>, Greeley",
  },
  "807": {
    // Prefix: "807",
    // State: "CO",
    // DistributionCenter: "Brighton",
    CitiesTowns: "<i>Fort Morgan</i>, Sterling",
  },
  "808": {
    // Prefix: "808",
    // State: "CO",
    // DistributionCenter: "Colorado Springs",
    CitiesTowns: "Burlington, Woodland Park, areas around Colorado Springs",
  },
  "809": {
    // Prefix: "809",
    // State: "CO",
    // DistributionCenter: "Colorado Springs",
    CitiesTowns: "COLORADO SPRINGS",
  },
  "810": {
    // Prefix: "810",
    // State: "CO",
    // DistributionCenter: "Pueblo",
    CitiesTowns: "Pueblo, Trinidad, Lamar",
  },
  "811": {
    // Prefix: "811",
    // State: "CO",
    // DistributionCenter: "Alamosa",
    CitiesTowns: "<i>Alamosa</i>, Pagosa Springs",
  },
  "812": {
    // Prefix: "812",
    // State: "CO",
    // DistributionCenter: "Salida",
    CitiesTowns: "<i>Salida</i>, Gunnison",
  },
  "813": {
    // Prefix: "813",
    // State: "CO",
    // DistributionCenter: "Durango",
    CitiesTowns: "<i>Durango</i>, Cortez",
  },
  "814": {
    // Prefix: "814",
    // State: "CO",
    // DistributionCenter: "Grand Junction",
    CitiesTowns: "<i>Montrose</i>, Telluride",
  },
  "815": {
    // Prefix: "815",
    // State: "CO",
    // DistributionCenter: "Grand Junction",
    CitiesTowns: "<i>Grand Junction</i>, Fruita",
  },
  "816": {
    // Prefix: "816",
    // State: "CO",
    // DistributionCenter: "Glenwood Springs",
    CitiesTowns: "<i>Glenwood Springs</i>, Craig, Aspen",
  },
  "817": {
    // Prefix: "817",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "818": {
    // Prefix: "818",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "819": {
    // Prefix: "819",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "820": {
    // Prefix: "820",
    // State: "WY",
    // DistributionCenter: "Cheyenne",
    CitiesTowns: "<i>Cheyenne</i>, Laramie",
  },
  "821": {
    // Prefix: "821",
    // State: "WY",
    // DistributionCenter: "Billings, MT",
    CitiesTowns: "YELLOWSTONE NATIONAL PARK",
  },
  "822": {
    // Prefix: "822",
    // State: "WY",
    // DistributionCenter: "Wheatland",
    CitiesTowns: "<i>Wheatland</i>, Torrington",
  },
  "823": {
    // Prefix: "823",
    // State: "WY",
    // DistributionCenter: "Rawlins",
    CitiesTowns: "<i>Rawlins</i>, Saratoga",
  },
  "824": {
    // Prefix: "824",
    // State: "WY",
    // DistributionCenter: "Worland",
    CitiesTowns: "<i>Worland</i>, Cody",
  },
  "825": {
    // Prefix: "825",
    // State: "WY",
    // DistributionCenter: "Riverton",
    CitiesTowns: "<i>Riverton</i>, Lander",
  },
  "826": {
    // Prefix: "826",
    // State: "WY",
    // DistributionCenter: "Casper",
    CitiesTowns: "<i>Casper</i>, Douglas",
  },
  "827": {
    // Prefix: "827",
    // State: "WY",
    // DistributionCenter: "Gillette",
    CitiesTowns: "Gillette, <i>Newcastle</i>",
  },
  "828": {
    // Prefix: "828",
    // State: "WY",
    // DistributionCenter: "Sheridan",
    CitiesTowns: "<i>Sheridan</i>, Buffalo",
  },
  "829": {
    // Prefix: "829",
    // State: "WY",
    // DistributionCenter: "Rock Springs",
    CitiesTowns: "<i>Rock Springs</i>, Evanston",
  },
  "830": {
    // Prefix: "830",
    // State: "WY",
    // DistributionCenter: "Rock Springs",
    CitiesTowns: "<i>Jackson</i>,",
  },
  "831": {
    // Prefix: "831",
    // State: "WY",
    // DistributionCenter: "Rock Springs",
    CitiesTowns: "<i>Kemmerer</i>, Afton",
  },
  "832": {
    // Prefix: "832",
    // State: "ID",
    // DistributionCenter: "Pocatello",
    CitiesTowns: "<i>Pocatello</i>, Challis",
  },
  "833": {
    // Prefix: "833",
    // State: "ID",
    // DistributionCenter: "Twin Falls",
    CitiesTowns: "<i>Twin Falls</i>, Sun Valley",
  },
  "834": {
    // Prefix: "834",
    // State: "ID",
    // DistributionCenter: "Pocatello",
    CitiesTowns: "<i>Idaho Falls</i>, Rexburg",
  },
  "835": {
    // Prefix: "835",
    // State: "ID",
    // DistributionCenter: "Lewiston",
    CitiesTowns: "<i>Lewiston</i>, Riggins",
  },
  "836": {
    // Prefix: "836",
    // State: "ID",
    // DistributionCenter: "Boise",
    CitiesTowns: "Nampa, Mountain Home, areas around Boise",
  },
  "837": {
    // Prefix: "837",
    // State: "ID",
    // DistributionCenter: "Boise",
    CitiesTowns: "BOISE",
  },
  "838": {
    // Prefix: "838",
    // State: "ID",
    // DistributionCenter: "Spokane, WA",
    CitiesTowns: "Coeur d'Alene, Moscow",
  },
  "839": {
    // Prefix: "839",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "840": {
    // Prefix: "840",
    // State: "UT",
    // DistributionCenter: "Salt Lake City",
    CitiesTowns: "Park City, Vernal, areas around Salt Lake City",
  },
  "841": {
    // Prefix: "841",
    // State: "UT",
    // DistributionCenter: "Salt Lake City",
    CitiesTowns: "SALT LAKE CITY",
  },
  "842": {
    // Prefix: "842",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "843": {
    // Prefix: "843",
    // State: "UT",
    // DistributionCenter: "Salt Lake City",
    CitiesTowns: "Logan, Brigham City, northern Utah",
  },
  "844": {
    // Prefix: "844",
    // State: "UT",
    // DistributionCenter: "Salt Lake City",
    CitiesTowns: "OGDEN",
  },
  "845": {
    // Prefix: "845",
    // State: "UT",
    // DistributionCenter: "Provo",
    CitiesTowns: "<i>Price</i>, Moab",
  },
  "846": {
    // Prefix: "846",
    // State: "UT",
    // DistributionCenter: "Provo",
    CitiesTowns: "<i>Provo</i>, Fillmore",
  },
  "847": {
    // Prefix: "847",
    // State: "UT",
    // DistributionCenter: "Provo",
    CitiesTowns: "<i>Richfield</i>, St. George",
  },
  "848": {
    // Prefix: "848",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "849": {
    // Prefix: "849",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "850": {
    // Prefix: "850",
    // State: "AZ",
    // DistributionCenter: "Phoenix",
    CitiesTowns: "PHOENIX",
  },
  "851": {
    // Prefix: "851",
    // State: "AZ",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "852": {
    // Prefix: "852",
    // State: "AZ",
    // DistributionCenter: "Phoenix",
    CitiesTowns: "<i>Mesa</i>, Scottsdale, eastern Phoenix suburbs",
  },
  "853": {
    // Prefix: "853",
    // State: "AZ",
    // DistributionCenter: "Phoenix",
    CitiesTowns: "Yuma, <i>Glendale</i>",
  },
  "854": {
    // Prefix: "854",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "855": {
    // Prefix: "855",
    // State: "AZ",
    // DistributionCenter: "Globe",
    CitiesTowns: "<i>Globe</i>, Safford",
  },
  "856": {
    // Prefix: "856",
    // State: "AZ",
    // DistributionCenter: "Tucson",
    CitiesTowns: "Sierra Vista, Nogales, areas around Tucson",
  },
  "857": {
    // Prefix: "857",
    // State: "AZ",
    // DistributionCenter: "Tucson",
    CitiesTowns: "TUCSON",
  },
  "858": {
    // Prefix: "858",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "859": {
    // Prefix: "859",
    // State: "AZ",
    // DistributionCenter: "Show Low",
    CitiesTowns: "<i>Show Low</i>, Eagar",
  },
  "860": {
    // Prefix: "860",
    // State: "AZ",
    // DistributionCenter: "Flagstaff",
    CitiesTowns: "<i>Flagstaff</i>, Grand Canyon",
  },
  "861": {
    // Prefix: "861",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "862": {
    // Prefix: "862",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "863": {
    // Prefix: "863",
    // State: "AZ",
    // DistributionCenter: "Prescott",
    CitiesTowns: "<i>Prescott</i>, Sedona",
  },
  "864": {
    // Prefix: "864",
    // State: "AZ",
    // DistributionCenter: "Kingman",
    CitiesTowns: "Kingman, Lake Havusu City",
  },
  "865": {
    // Prefix: "865",
    // State: "AZ",
    // DistributionCenter: "Gallup, NM",
    CitiesTowns: "Chinle, Chambers",
  },
  "866": {
    // Prefix: "866",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "867": {
    // Prefix: "867",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "868": {
    // Prefix: "868",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "869": {
    // Prefix: "869",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "870": {
    // Prefix: "870",
    // State: "NM",
    // DistributionCenter: "Albuquerque",
    CitiesTowns: "Grants, Los Lunas, areas around Albuquerque",
  },
  "871": {
    // Prefix: "871",
    // State: "NM",
    // DistributionCenter: "Albuquerque",
    CitiesTowns: "ALBUQUERQUE",
  },
  "872": {
    // Prefix: "872",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "873": {
    // Prefix: "873",
    // State: "NM",
    // DistributionCenter: "Gallup",
    CitiesTowns: "<i>Gallup</i>, Zuni",
  },
  "874": {
    // Prefix: "874",
    // State: "NM",
    // DistributionCenter: "Farmington",
    CitiesTowns: "<i>Farmington</i>, Shiprock",
  },
  "875": {
    // Prefix: "875",
    // State: "NM",
    // DistributionCenter: "Albuquerque",
    CitiesTowns: "<i>Santa Fe</i>, Taos",
  },
  "876": {
    // Prefix: "876",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "877": {
    // Prefix: "877",
    // State: "NM",
    // DistributionCenter: "Las Vegas",
    CitiesTowns: "<i>Las Vegas</i>, Raton",
  },
  "878": {
    // Prefix: "878",
    // State: "NM",
    // DistributionCenter: "Socorro",
    CitiesTowns: "<i>Socorro</i>, Magdelena",
  },
  "879": {
    // Prefix: "879",
    // State: "NM",
    // DistributionCenter: "<small>Truth or Consequences</small>",
    CitiesTowns: "<i>Truth or Consequences</i>, Hatch",
  },
  "880": {
    // Prefix: "880",
    // State: "NM",
    // DistributionCenter: "Las Cruces",
    CitiesTowns: "<i>Las Cruces</i>, Silver City",
  },
  "881": {
    // Prefix: "881",
    // State: "NM",
    // DistributionCenter: "Clovis",
    CitiesTowns: "<i>Clovis</i>, Fort Sumner",
  },
  "882": {
    // Prefix: "882",
    // State: "NM",
    // DistributionCenter: "Roswell",
    CitiesTowns: "<i>Roswell</i>, Carlsbad",
  },
  "883": {
    // Prefix: "883",
    // State: "NM",
    // DistributionCenter: "Carrizozo",
    CitiesTowns: "<i>Carrizozo</i>, Alamogordo",
  },
  "884": {
    // Prefix: "884",
    // State: "NM",
    // DistributionCenter: "Tucumcari",
    CitiesTowns: "<i>Tucumcari</i>, Clayton",
  },
  "885": {
    // Prefix: "885",
    // State: "NM",
    // DistributionCenter: "El Paso, TX",
    CitiesTowns: "Fort Bliss",
  },
  "886": {
    // Prefix: "886",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "887": {
    // Prefix: "887",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "888": {
    // Prefix: "888",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "889": {
    // Prefix: "889",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "890": {
    // Prefix: "890",
    // State: "NV",
    // DistributionCenter: "Las Vegas",
    CitiesTowns: "Laughlin, Tonopah, areas around Las Vegas",
  },
  "891": {
    // Prefix: "891",
    // State: "NV",
    // DistributionCenter: "Las Vegas",
    CitiesTowns: "LAS VEGAS",
  },
  "892": {
    // Prefix: "892",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "893": {
    // Prefix: "893",
    // State: "NV",
    // DistributionCenter: "Ely",
    CitiesTowns: "<i>Ely</i>, Eureka",
  },
  "894": {
    // Prefix: "894",
    // State: "NV",
    // DistributionCenter: "Reno",
    CitiesTowns: "Winnemucca, Sparks, areas around Reno",
  },
  "895": {
    // Prefix: "895",
    // State: "NV",
    // DistributionCenter: "Reno",
    CitiesTowns: "RENO",
  },
  "896": {
    // Prefix: "896",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "897": {
    // Prefix: "897",
    // State: "NV",
    // DistributionCenter: "Reno",
    CitiesTowns: "CARSON CITY",
  },
  "898": {
    // Prefix: "898",
    // State: "NV",
    // DistributionCenter: "Elko",
    CitiesTowns: "<i>Elko</i>, West Wendover",
  },
  "899": {
    // Prefix: "899",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "900": {
    // Prefix: "900",
    // State: "CA",
    // DistributionCenter: "Los Angeles",
    CitiesTowns: "LOS ANGELES",
  },
  "901": {
    // Prefix: "901",
    // State: "CA",
    // DistributionCenter: "Los Angeles",
    CitiesTowns: "LOS ANGELES",
  },
  "902": {
    // Prefix: "902",
    // State: "CA",
    // DistributionCenter: "Inglewood",
    CitiesTowns: "Beverly Hills, Culver City, Towns in Southern and Eastern L.A. County",
  },
  "903": {
    // Prefix: "903",
    // State: "CA",
    // DistributionCenter: "Inglewood",
    CitiesTowns: "INGLEWOOD",
  },
  "904": {
    // Prefix: "904",
    // State: "CA",
    // DistributionCenter: "Inglewood",
    CitiesTowns: "SANTA MONICA",
  },
  "905": {
    // Prefix: "905",
    // State: "CA",
    // DistributionCenter: "Inglewood",
    CitiesTowns: "TORRANCE",
  },
  "906": {
    // Prefix: "906",
    // State: "CA",
    // DistributionCenter: "Long Beach",
    CitiesTowns: "<i>Whittier</i>, Buena Park, Norwalk",
  },
  "907": {
    // Prefix: "907",
    // State: "CA",
    // DistributionCenter: "Long Beach",
    CitiesTowns: "Artesia, San Pedro, areas around Long Beach",
  },
  "908": {
    // Prefix: "908",
    // State: "CA",
    // DistributionCenter: "Long Beach",
    CitiesTowns: "LONG BEACH",
  },
  "909": {
    // Prefix: "909",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "910": {
    // Prefix: "910",
    // State: "CA",
    // DistributionCenter: "Pasadena",
    CitiesTowns: "Arcadia, La Canada, areas around Pasadena",
  },
  "911": {
    // Prefix: "911",
    // State: "CA",
    // DistributionCenter: "Pasadena",
    CitiesTowns: "PASADENA",
  },
  "912": {
    // Prefix: "912",
    // State: "CA",
    // DistributionCenter: "Pasadena",
    CitiesTowns: "GLENDALE",
  },
  "913": {
    // Prefix: "913",
    // State: "CA",
    // DistributionCenter: "Van Nuys",
    CitiesTowns: "Most of the San Fernando Valley, Thousand Oaks",
  },
  "914": {
    // Prefix: "914",
    // State: "CA",
    // DistributionCenter: "Van Nuys",
    CitiesTowns: "VAN NUYS",
  },
  "915": {
    // Prefix: "915",
    // State: "CA",
    // DistributionCenter: "Van Nuys",
    CitiesTowns: "BURBANK",
  },
  "916": {
    // Prefix: "916",
    // State: "CA",
    // DistributionCenter: "Van Nuys",
    CitiesTowns: "NORTH HOLLYWOOD",
  },
  "917": {
    // Prefix: "917",
    // State: "CA",
    // DistributionCenter: "Industry",
    CitiesTowns: "Ontario, Most of the San Gabriel Valley",
  },
  "918": {
    // Prefix: "918",
    // State: "CA",
    // DistributionCenter: "Industry",
    CitiesTowns: "ALHAMBRA",
  },
  "919": {
    // Prefix: "919",
    // State: "CA",
    // DistributionCenter: "San Diego",
    CitiesTowns: "Chula Vista, El Cajon, Towns south and east of San Diego",
  },
  "920": {
    // Prefix: "920",
    // State: "CA",
    // DistributionCenter: "San Diego",
    CitiesTowns: "Escondido, Oceanside, Towns north of San Diego",
  },
  "921": {
    // Prefix: "921",
    // State: "CA",
    // DistributionCenter: "San Diego",
    CitiesTowns: "SAN DIEGO",
  },
  "922": {
    // Prefix: "922",
    // State: "CA",
    // DistributionCenter: "Palm Springs",
    CitiesTowns: "Palm Springs, El Centro, Coachella Valley, Imperial County",
  },
  "923": {
    // Prefix: "923",
    // State: "CA",
    // DistributionCenter: "San Bernardino",
    CitiesTowns: "Barstow, Fontana, Most of San Bernardino County",
  },
  "924": {
    // Prefix: "924",
    // State: "CA",
    // DistributionCenter: "San Bernardino",
    CitiesTowns: "SAN BERNARDINO",
  },
  "925": {
    // Prefix: "925",
    // State: "CA",
    // DistributionCenter: "San Bernardino",
    CitiesTowns: "Riverside, Temecula, Most of Riverside County",
  },
  "926": {
    // Prefix: "926",
    // State: "CA",
    // DistributionCenter: "Santa Ana",
    CitiesTowns: "Huntington Beach, Irvine, Mission Viejo, Southern Orange County",
  },
  "927": {
    // Prefix: "927",
    // State: "CA",
    // DistributionCenter: "Santa Ana",
    CitiesTowns: "SANTA ANA",
  },
  "928": {
    // Prefix: "928",
    // State: "CA",
    // DistributionCenter: "Santa Ana",
    CitiesTowns: "Anaheim, Fullerton, Northern Orange County",
  },
  "929": {
    // Prefix: "929",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "930": {
    // Prefix: "930",
    // State: "CA",
    // DistributionCenter: "Oxnard",
    CitiesTowns: "Oxnard, Simi Valley, <i>Ventura</i>",
  },
  "931": {
    // Prefix: "931",
    // State: "CA",
    // DistributionCenter: "Santa Barbara",
    CitiesTowns: "SANTA BARBARA",
  },
  "932": {
    // Prefix: "932",
    // State: "CA",
    // DistributionCenter: "Bakersfield",
    CitiesTowns: "Visalia, Arvin, Hanford, Towns around Bakersfield",
  },
  "933": {
    // Prefix: "933",
    // State: "CA",
    // DistributionCenter: "Bakersfield",
    CitiesTowns: "BAKERSFIELD",
  },
  "934": {
    // Prefix: "934",
    // State: "CA",
    // DistributionCenter: "Santa Barbara",
    CitiesTowns: "<i>San Luis Obispo</i>, Santa Maria",
  },
  "935": {
    // Prefix: "935",
    // State: "CA",
    // DistributionCenter: "Mojave",
    CitiesTowns: "<i>Mojave</i>, Bishop, Lancaster, High Desert",
  },
  "936": {
    // Prefix: "936",
    // State: "CA",
    // DistributionCenter: "Fresno",
    CitiesTowns: "Madera, Reedley, areas around Fresno",
  },
  "937": {
    // Prefix: "937",
    // State: "CA",
    // DistributionCenter: "Fresno",
    CitiesTowns: "FRESNO",
  },
  "938": {
    // Prefix: "938",
    // State: "CA",
    // DistributionCenter: "Fresno",
    CitiesTowns: "IRS",
  },
  "939": {
    // Prefix: "939",
    // State: "CA",
    // DistributionCenter: "Salinas",
    CitiesTowns: "<i>Salinas</i>, Monterey",
  },
  "940": {
    // Prefix: "940",
    // State: "CA",
    // DistributionCenter: "San Francisco",
    CitiesTowns: "Redwood City, Daly City, towns south of San Francisco",
  },
  "941": {
    // Prefix: "941",
    // State: "CA",
    // DistributionCenter: "San Francisco",
    CitiesTowns: "SAN FRANCISCO",
  },
  "942": {
    // Prefix: "942",
    // State: "CA",
    // DistributionCenter: "Sacramento",
    CitiesTowns: "California Government",
  },
  "943": {
    // Prefix: "943",
    // State: "CA",
    // DistributionCenter: "San Francisco",
    CitiesTowns: "PALO ALTO",
  },
  "944": {
    // Prefix: "944",
    // State: "CA",
    // DistributionCenter: "San Francisco",
    CitiesTowns: "SAN MATEO",
  },
  "945": {
    // Prefix: "945",
    // State: "CA",
    // DistributionCenter: "Oakland",
    CitiesTowns: "Napa, Fremont, areas around Oakland and the East Bay",
  },
  "946": {
    // Prefix: "946",
    // State: "CA",
    // DistributionCenter: "Oakland",
    CitiesTowns: "OAKLAND",
  },
  "947": {
    // Prefix: "947",
    // State: "CA",
    // DistributionCenter: "Oakland",
    CitiesTowns: "BERKELEY",
  },
  "948": {
    // Prefix: "948",
    // State: "CA",
    // DistributionCenter: "Oakland",
    CitiesTowns: "RICHMOND",
  },
  "949": {
    // Prefix: "949",
    // State: "CA",
    // DistributionCenter: "North Bay",
    CitiesTowns: "<i>San Rafael</i>, Petaluma, North Bay",
  },
  "950": {
    // Prefix: "950",
    // State: "CA",
    // DistributionCenter: "San Jose",
    CitiesTowns: "Santa Cruz, Santa Clara, areas around San Jose",
  },
  "951": {
    // Prefix: "951",
    // State: "CA",
    // DistributionCenter: "San Jose",
    CitiesTowns: "SAN JOSE",
  },
  "952": {
    // Prefix: "952",
    // State: "CA",
    // DistributionCenter: "Stockton",
    CitiesTowns: "<i>Stockton</i>, Angels Camp",
  },
  "953": {
    // Prefix: "953",
    // State: "CA",
    // DistributionCenter: "Stockton",
    CitiesTowns: "Modesto, Merced",
  },
  "954": {
    // Prefix: "954",
    // State: "CA",
    // DistributionCenter: "North Bay",
    CitiesTowns: "<i>Santa Rosa</i>, Ukiah",
  },
  "955": {
    // Prefix: "955",
    // State: "CA",
    // DistributionCenter: "Eureka",
    CitiesTowns: "<i>Eureka</i>, Crescent City",
  },
  "956": {
    // Prefix: "956",
    // State: "CA",
    // DistributionCenter: "Sacramento",
    CitiesTowns: "Davis, Auburn, towns around Sacramento",
  },
  "957": {
    // Prefix: "957",
    // State: "CA",
    // DistributionCenter: "Sacramento",
    CitiesTowns: "Colfax, Roseville, towns around Sacremento",
  },
  "958": {
    // Prefix: "958",
    // State: "CA",
    // DistributionCenter: "Sacramento",
    CitiesTowns: "SACRAMENTO",
  },
  "959": {
    // Prefix: "959",
    // State: "CA",
    // DistributionCenter: "Marysville",
    CitiesTowns: "<i>Marysville</i>, Chico",
  },
  "960": {
    // Prefix: "960",
    // State: "CA",
    // DistributionCenter: "Redding",
    CitiesTowns: "<i>Redding</i>, Yreka",
  },
  "961": {
    // Prefix: "961",
    // State: "CA",
    // DistributionCenter: "Reno, NV",
    CitiesTowns: "Susanville, South Lake Tahoe",
  },
  "962": {
    // Prefix: "962",
    // State: "AP",
    // DistributionCenter: "San Francisco, CA",
    CitiesTowns: "Bases in Korea",
  },
  "963": {
    // Prefix: "963",
    // State: "AP",
    // DistributionCenter: "San Francisco, CA",
    CitiesTowns: "Bases in Japan",
  },
  "964": {
    // Prefix: "964",
    // State: "AP",
    // DistributionCenter: "San Francisco, CA",
    CitiesTowns: "Bases in the Philippines",
  },
  "965": {
    // Prefix: "965",
    // State: "AP",
    // DistributionCenter: "San Francisco, CA",
    CitiesTowns: "Bases in the Pacific",
  },
  "966": {
    // Prefix: "966",
    // State: "AP",
    // DistributionCenter: "San Francisco, CA",
    CitiesTowns: "Pacific Ocean Ships",
  },
  "967": {
    // Prefix: "967",
    // State: "HI",
    // DistributionCenter: "Honolulu",
    CitiesTowns: "American Samoa; Hilo, Kahului, towns around Honolulu",
  },
  "968": {
    // Prefix: "968",
    // State: "HI",
    // DistributionCenter: "Honolulu",
    CitiesTowns: "HONOLULU",
  },
  "969": {
    // Prefix: "969",
    // State: "GU",
    // DistributionCenter: "Barrigada",
    CitiesTowns: "Guam, N. Mariana Islands, Palau, Micronesia, Marshall Islands",
  },
  "970": {
    // Prefix: "970",
    // State: "OR",
    // DistributionCenter: "Portland",
    CitiesTowns: "The Dalles, Beaverton, areas around Portland",
  },
  "971": {
    // Prefix: "971",
    // State: "OR",
    // DistributionCenter: "Portland",
    CitiesTowns: "Astoria, Hillsboro, areas west of Portland",
  },
  "972": {
    // Prefix: "972",
    // State: "OR",
    // DistributionCenter: "Portland",
    CitiesTowns: "PORTLAND",
  },
  "973": {
    // Prefix: "973",
    // State: "OR",
    // DistributionCenter: "Salem",
    CitiesTowns: "<i>Salem</i>, Corvallis",
  },
  "974": {
    // Prefix: "974",
    // State: "OR",
    // DistributionCenter: "Eugene",
    CitiesTowns: "<i>Eugene</i>, Coos Bay",
  },
  "975": {
    // Prefix: "975",
    // State: "OR",
    // DistributionCenter: "Medford",
    CitiesTowns: "<i>Medford</i>, Grants Pass",
  },
  "976": {
    // Prefix: "976",
    // State: "OR",
    // DistributionCenter: "Klamath Falls",
    CitiesTowns: "<i>Klamath Falls</i>, Lakeview",
  },
  "977": {
    // Prefix: "977",
    // State: "OR",
    // DistributionCenter: "Bend",
    CitiesTowns: "<i>Bend</i>, Burns",
  },
  "978": {
    // Prefix: "978",
    // State: "OR",
    // DistributionCenter: "Pendleton",
    CitiesTowns: "<i>Pendleton</i>, Baker City",
  },
  "979": {
    // Prefix: "979",
    // State: "OR",
    // DistributionCenter: "Boise, ID",
    CitiesTowns: "Ontario, Jordan Valley",
  },
  "980": {
    // Prefix: "980",
    // State: "WA",
    // DistributionCenter: "Seattle",
    CitiesTowns: "Bellevue, Auburn, areas around Seattle",
  },
  "981": {
    // Prefix: "981",
    // State: "WA",
    // DistributionCenter: "Seattle",
    CitiesTowns: "SEATTLE",
  },
  "982": {
    // Prefix: "982",
    // State: "WA",
    // DistributionCenter: "Everett",
    CitiesTowns: "<i>Everett</i>, Bellingham",
  },
  "983": {
    // Prefix: "983",
    // State: "WA",
    // DistributionCenter: "Tacoma",
    CitiesTowns: "Port Angeles, Puyallup, areas around Tacoma",
  },
  "984": {
    // Prefix: "984",
    // State: "WA",
    // DistributionCenter: "Tacoma",
    CitiesTowns: "TACOMA",
  },
  "985": {
    // Prefix: "985",
    // State: "WA",
    // DistributionCenter: "Olympia",
    CitiesTowns: "Olympia, Aberdeen",
  },
  "986": {
    // Prefix: "986",
    // State: "WA",
    // DistributionCenter: "Portland, OR",
    CitiesTowns: "Vancouver, Longview",
  },
  "987": {
    // Prefix: "987",
    // State: "NOT USED",
    // DistributionCenter: "NOT USED",
    CitiesTowns: "NOT USED",
  },
  "988": {
    // Prefix: "988",
    // State: "WA",
    // DistributionCenter: "Wenatchee",
    CitiesTowns: "<i>Wenatchee</i>, Moses Lake",
  },
  "989": {
    // Prefix: "989",
    // State: "WA",
    // DistributionCenter: "Yakima",
    CitiesTowns: "<i>Yakima</i>, Ellensburg",
  },
  "990": {
    // Prefix: "990",
    // State: "WA",
    // DistributionCenter: "Spokane",
    CitiesTowns: "Cheney, Liberty Lake, areas around Spokane",
  },
  "991": {
    // Prefix: "991",
    // State: "WA",
    // DistributionCenter: "Spokane",
    CitiesTowns: "Pullman, Colville, areas distant to Spokane",
  },
  "992": {
    // Prefix: "992",
    // State: "WA",
    // DistributionCenter: "Spokane",
    CitiesTowns: "SPOKANE",
  },
  "993": {
    // Prefix: "993",
    // State: "WA",
    // DistributionCenter: "Pasco",
    CitiesTowns: "<i>Pasco</i>, Walla Walla",
  },
  "994": {
    // Prefix: "994",
    // State: "WA",
    // DistributionCenter: "Lewiston, ID",
    CitiesTowns: "Clarkston, Asotin",
  },
  "995": {
    // Prefix: "995",
    // State: "AK",
    // DistributionCenter: "Anchorage",
    CitiesTowns: "<i>Anchorage</i>, Bethel, areas in and around Anchorage A-G",
  },
  "996": {
    // Prefix: "996",
    // State: "AK",
    // DistributionCenter: "Anchorage",
    CitiesTowns: "Homer, Unalaska, areas around Anchorage H-Z",
  },
  "997": {
    // Prefix: "997",
    // State: "AK",
    // DistributionCenter: "Fairbanks",
    CitiesTowns: "<i>Fairbanks</i>, Nome",
  },
  "998": {
    // Prefix: "998",
    // State: "AK",
    // DistributionCenter: "Juneau",
    CitiesTowns: "<i>Juneau</i>, Sitka",
  },
  "999": {
    // Prefix: "999",
    // State: "AK",
    // DistributionCenter: "Ketchikan",
    CitiesTowns: "<i>Ketchikan</i>, Wrangell",
  },
};
